export default {
  common: { loading: 'Cargando…', noData: 'Sin datos', clear: 'Borrar', delete: 'Eliminar' },
  errors: { /* notices-i18n */
    generic: 'Algo salió mal. Inténtalo de nuevo.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Este día tiene una ausencia aprobada de día completo — no se puede registrar tiempo de trabajo en él.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Según tu contrato, solo registras tiempo de proyecto, no tiempo de trabajo.',
      week_approved: 'Esta semana ya está aprobada y bloqueada: solo se puede cambiar con una solicitud de corrección.',
      week_submitted: 'Esta semana está enviada y pendiente de decisión: solo se puede cambiar cuando se retire o se devuelva.',
      already_clocked_in: 'Ya has fichado la entrada. Cierra primero el tiempo de trabajo en curso.',
      block_overlap: 'Este tiempo de trabajo se solapa con otro.',
      block_locked: 'Este tiempo de trabajo está bloqueado por una semana cerrada. Solicita una corrección.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Desactiva «Exigir inicio de sesión solo mediante SSO» antes de cambiar la URL del emisor o el Client ID.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'Uno de los dominios de correo no es un dominio. Introduce dominios como example.com, sin comodines ni direcciones web.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Este campo está declarado como categoría especial y la declaración no se puede retirar.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Un campo no puede rellenarse con nada.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Este aviso no tiene ningún campo con ese nombre.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Un valor no puede contener otro campo por rellenar.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Las invitaciones están en pausa hasta que se rellenen todos los campos de los avisos para empleados en Avisos legales. Pide a la persona propietaria del workspace, a una administración de suite o a la persona delegada de protección de datos que los complete.',
      LEGAL_READINESS_UNAVAILABLE: 'No hemos podido comprobar si los avisos para empleados están completos. Inténtalo de nuevo en unos minutos.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Facturación', status: 'Estado', paymentMethod: 'Método de pago',
    updateCard: 'Reemplazar tarjeta', addCard: 'Añadir tarjeta',
    invoices: 'Facturas', charges: 'Pagos',
    noInvoices: 'Aún no hay facturas.', noCharges: 'Aún no hay pagos.',
    noCard: 'Ninguna registrada', validUntil: 'válida hasta {date}',
    trialDaysLeft: '{days} días restantes de prueba', trialExpired: 'Prueba caducada',
    trialDaysLeftUntil: '{days} días restantes de prueba — termina el {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: 'Quedan {days} días gratis — hasta el {date}',
    nextChargeOn: 'Próximo cargo el {date}',
    exempt: { badge: 'Exento de facturación', note: 'lumi ha acordado que este espacio de trabajo no se factura por ahora.' },
    download: 'Descargar', dangerZone: 'Zona de peligro',
    col: { date: 'Fecha', period: 'Período', net: 'Neto', vat: 'IVA', gross: 'Bruto', status: 'Estado', kind: 'Tipo', amount: 'Importe', document: 'Factura' },
    statusLabel: { trialing: 'Prueba', active: 'Activo', delinquent: 'Pago pendiente', closed: 'Cerrado', canceled: 'Cancelado' },
    tab: { plans: 'Planes', paymentMethod: 'Método de pago', invoices: 'Facturas y pagos', referral: 'Recomendaciones', externalPostings: 'Anuncios de empleo', dangerZone: 'Cancelar y eliminar' },
    externalPostings: {
      title: 'Anuncios en portales de empleo externos',
      intro: 'Los anuncios en portales de empleo externos se piden uno a uno y se facturan por pedido: hasta varios miles de euros cada uno. Con esta opción activada, puede hacer esos pedidos quien tenga en su rol de selección el permiso «Publicar en el exterior (de pago)»; al principio, solo los administradores de selección; cada pedido se factura a este espacio de trabajo.',
      switchLabel: 'Permitir pedir anuncios en portales de empleo externos',
      saving: 'Guardando',
      offHint: 'Desactivarlo solo detiene los pedidos nuevos. Los anuncios que ya están publicados siguen online y se siguen facturando hasta que termine su plazo.',
      offHintOpenOrders: 'Ahora mismo hay anuncios publicados. Desactivarlo solo detiene los pedidos nuevos: los anuncios en curso siguen online y se siguen facturando hasta que termine su plazo.',
      roleNote: 'Solo el propietario del espacio de trabajo, un responsable de facturación o un administrador de la suite pueden cambiar este ajuste. A quien no deba pedir anuncios se le frena en selección, retirando de su rol el permiso «Publicar en el exterior (de pago)».',
      demoNote: 'Este es un espacio de trabajo de demostración. Sus ajustes se sustituyen al hacer la configuración real, así que este interruptor permanece bloqueado hasta entonces.',
      noCardTitle: 'No hay método de pago registrado',
      noCardBody: 'Puedes activarlo ahora, pero un pedido de anuncio no se podrá pagar hasta que haya una tarjeta registrada.',
      noCardCta: 'Añadir tarjeta',
      savedOn: 'Los anuncios externos están activados. Los recruiters verán la sección de pedido en su próxima carga de página.',
      savedOff: 'Los anuncios externos están desactivados. No se pueden pedir anuncios nuevos; los que ya están publicados siguen online y se siguen facturando.',
    },
    invoiceStatus: { draft: 'En preparación', issued: 'Emitida', sent: 'Enviada', canceled: 'Anulada' },
    chargeKind: { subscription: 'Suscripción', proration: 'Prorrateo', posting: 'Anuncio de empleo', recovery: 'Pago de recuperación' },
    posting: { orderRef: 'Pedido {ref}', invoice: 'Descargar factura' },
    chargeStatus: { created: 'Creado', pending: 'Pendiente', paid: 'Pagado', failed: 'Fallido', authorized: 'Retenido', order_placed: 'Cursado', capture_requested: 'Cobro solicitado', captured: 'Pagado', settled: 'Pagado', refunded: 'Reembolsado', chargeback: 'Contracargo', voided: 'Fallido' },
    bill: { label: 'Factura {number}', labelMany: 'Facturas {number}', unnumbered: 'Factura en preparación', paid: 'Pagada', closed: 'Cerrada', retry: 'Reintento', projected: 'Previsto' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Prueba hasta el {start} · después, 1 mes gratis hasta el {end} · código {code} | Prueba hasta el {start} · después, {n} meses gratis hasta el {end} · código {code}', run: 'Meses gratis hasta el {end} · código {code}', discount: 'Prueba hasta el {start} · después, 1 mes con un {percent} % de descuento en plazas y módulos · código {code} | Prueba hasta el {start} · después, {n} meses con un {percent} % de descuento en plazas y módulos · código {code}', discountRun: '{percent} % de descuento en plazas y módulos hasta el {end} · código {code}', invoiceLine: 'Código promocional {code} −{percent} %', referralLine: 'Bonificación por recomendación −{percent} %', referralLineCapped: 'Bonificación por recomendación −{percent} % (limitado)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Código promocional (opcional)', apply: 'Aplicar', remove: 'Quitar', applied: '{code}: {percent} % de descuento en {module} durante 1 factura | {code}: {percent} % de descuento en {module} durante {n} facturas', savesToday: 'El código descuenta {amount} del cargo de hoy.', rateLimited: 'Demasiados intentos. Espera unos minutos y vuelve a intentarlo.', checkFailed: 'Ahora mismo no se puede comprobar el código. Puedes añadir el módulo sin él.', notBooked: 'No se ha contratado nada: puedes añadir el módulo sin el código.', addedWithoutDiscount: 'No se pudo aplicar el código, así que no hay descuento.', module: { time_tracking: 'Control horario' }, trimmed: '{code} da un {percent} %, pero tu factura ya lleva un descuento: en {module} obtienes un {effective} % (todos los descuentos de una factura tienen un tope).', trimmedNothing: '{code} da un {percent} %, pero tu factura ya lleva un descuento: este código no añade nada por ahora.', pending: 'Aún estamos confirmando tu código: aparecerá en tu próxima factura cuando se confirme.', invoiceLine: 'Código promocional {code} −{percent} % ({module})', running: '{code}: {percent} % de descuento en 1 factura más | {code}: {percent} % de descuento en {n} facturas más', reason: { unknown: 'No conocemos este código. Comprueba cómo está escrito.', disabled: 'Este código se ha desactivado.', notYetValid: 'Este código todavía no es válido.', expired: 'Este código ha caducado.', exhausted: 'Ya has usado este código, o se ha agotado.', moduleNotEligible: 'Este código no cubre {module}.', wrongCheckout: 'Este código es para altas nuevas, no para añadir un módulo.', unavailable: 'Este código no se puede usar aquí.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Tu código de recomendación', copy: 'Copiar código', copyLink: 'Copiar enlace de contratación', copied: 'Código de recomendación copiado', linkCopied: 'Enlace de contratación copiado', friendGets: 'Quien use tu código recibe un {percent} % de descuento en su primer mes de pago. | Quien use tu código recibe un {percent} % de descuento en sus primeros {n} meses de pago.', youGet: 'Por cada empresa que empieza a pagar con tu código: un {percent} % de descuento en una de tus facturas — varios se suman, hasta un {ceiling} % por factura. | Por cada empresa que empieza a pagar con tu código: un {percent} % de descuento en {n} de tus facturas — varios se suman, hasta un {ceiling} % por factura.', youGetCapped: 'Por cada empresa que empieza a pagar con tu código: un {percent} % de descuento en una de tus facturas — varios se suman, hasta un {ceiling} % por factura; cada bonificación descuenta como máximo {cap} por factura. | Por cada empresa que empieza a pagar con tu código: un {percent} % de descuento en {n} de tus facturas — varios se suman, hasta un {ceiling} % por factura; cada bonificación descuenta como máximo {cap} por factura.', paused: 'Tu código está en pausa mientras haya una solicitud de eliminación abierta para tu espacio de trabajo. Vuelve a funcionar en cuanto se retire.', disabled: 'Este código se ha desactivado y ya no se puede usar.', none: { trialing: 'Recibirás un código de recomendación cuando tu espacio de trabajo pague, después de la prueba.', free_run: 'Recibirás un código de recomendación cuando terminen los meses gratis y tu espacio de trabajo pague.', not_billing: 'Recibirás un código de recomendación cuando tu espacio de trabajo tenga una suscripción en curso.' }, loading: 'Cargando tu código de recomendación …', error: 'Ahora mismo no se ha podido leer tu código de recomendación. Inténtalo de nuevo más tarde.', bonus: { title: 'Tus bonificaciones por recomendación', collect: 'Canjear', ready: 'listo para canjear', startsOn: 'a partir de tu factura del {date}', startsNext: 'a partir de tu próxima factura', waits: 'espera sitio en una próxima factura', carries: 'Tu próxima factura incluye {items}.', capped: 'limitado', running: { promo: '{percent} % de código promocional', module: '{percent} % de código de módulo', referral: '{percent} % de bonificación por recomendación' }, collected: 'Canjeado: la bonificación se descontará ahora de tus próximas facturas.', alreadyRunning: 'Esta bonificación ya está en marcha.', collectFailed: 'No se ha podido canjear la bonificación ahora mismo. Inténtalo de nuevo.', hint: { ceiling: 'Todavía no: tu próxima factura ya incluye {running}, y con esta bonificación superaría el límite del {ceiling} %.', ceilingRunning: 'Todavía no: tu próxima factura ya incluye {running}, lo que no deja sitio para esta bonificación.', ceilingLimit: 'Todavía no: con esta bonificación, tu próxima factura superaría el límite del {ceiling} %.', ceilingPlain: 'Todavía no: los descuentos de tu próxima factura no dejan sitio para esta bonificación.', roomNext: 'Una bonificación en curso termina con tu próxima factura.', roomLater: 'La primera bonificación en curso termina dentro de {n} facturas.', notActive: 'Esta bonificación espera hasta que tu espacio de trabajo vuelva a estar activo.', deletion: 'Esta bonificación espera mientras haya una solicitud de eliminación abierta para tu espacio de trabajo.', unavailable: 'Ahora mismo no se puede comprobar si esta bonificación puede canjearse. Inténtalo de nuevo en un momento.' } }, history: { title: 'Tus recomendaciones', empty: 'Nadie ha usado todavía tu código.', waiting: 'Usado el {date} — a la espera de su primer mes de pago', bonusEarned: 'Obtenido el {date}: {percent} % de descuento en 1 factura | Obtenido el {date}: {percent} % de descuento en {n} facturas', bonusCap: ', limitado a {cap} por factura', bonusOn: 'en tu factura de {months} | en tus facturas de {months}', bonusToCome: '{n} por venir', bonusNone: 'aún en ninguna factura' } },
    errors: { setupFailed: 'Error al configurar la tarjeta.', loadFailed: 'No se pudieron cargar los datos de facturación.', ownerOnly: 'Solo el propietario del espacio de trabajo puede gestionar la facturación.', planChangeFailed: 'No se pudo cambiar tu plan. Inténtalo de nuevo.', paymentStanding: 'Resuelve tu pago pendiente antes de mejorar el plan.', cardRequired: 'Añade una tarjeta válida antes de mejorar el plan.', addModuleFailed: 'No se pudo añadir el módulo. Inténtalo de nuevo.', cancellationPending: 'Tu suscripción va a finalizar. Elige primero «Mantener suscripción» y después añade el módulo.', removeFailed: 'No se pudo programar la eliminación. Inténtalo de nuevo.' },
    retry: 'Reintentar',
    common: { close: 'Cerrar' },
    card: {
      label: 'Tarjeta', title: 'Método de pago',
      remove: 'Quitar tarjeta', removed: 'Tarjeta eliminada.',
      inUse: 'Esta tarjeta ya se ha facturado y solo puede sustituirse, no eliminarse.',
      removeConfirmTitle: '¿Quitar la tarjeta?', removeConfirmBody: 'Esto elimina la tarjeta registrada. Puedes añadir una nueva en cualquier momento.',
      removeError: 'No se pudo quitar la tarjeta.',
      handoff: 'Enviar un enlace de pago a otra persona', handoffTitle: 'Enlace de pago',
      handoffHint: '«Añadir/reemplazar tarjeta»: introduces tú mismo los datos de la tarjeta. «Enviar un enlace de pago a otra persona»: envía un enlace de un solo uso a quien configure la tarjeta, p. ej. tu departamento de contabilidad.',
      handoffBody: 'Comparte este enlace de un solo uso con quien vaya a configurar la tarjeta. Caduca el {date}.',
      copy: 'Copiar', copied: 'Copiado', handoffCopied: 'Enlace de pago copiado', handoffError: 'No se pudo crear un enlace de pago.',
    },
    recovery: {
      title: 'Pago pendiente · {amount}',
      body: 'Tu banco debe confirmar este pago. Confírmalo ahora para conservar tu acceso.',
      cta: 'Confirmar pago',
      paid: 'Pago recibido: tu acceso se ha restablecido.',
      failed: 'El pago no se completó. Puedes intentarlo de nuevo en cualquier momento.',
      checking: 'Todavía estamos comprobando el pago…',
      startError: 'No se pudo iniciar el pago ahora mismo. Inténtalo de nuevo en un momento.',
    },
    plan: {
      title: 'Plan y módulos', subtitle: 'Gestiona el plan de cada módulo activo.',
      currentPlan: 'Plan actual', current: 'Actual',
      perMonth: '{amount}/mes', perUserMonth: '{amount} por usuario/mes', perApprenticeMonth: '{amount} por aprendiz/mes', volumeHint: 'Descuento por volumen: los workspaces más grandes pagan automáticamente menos por plaza.',
      perUpgradeMonth: '{amount} por ampliación/mes',
      upgrade: 'Mejorar', downgrade: 'Reducir', apply: 'Cambiar plan',
      downgradeNote: 'Las reducciones surten efecto al inicio de tu próximo ciclo de facturación.',
      fixCardCta: 'Corregir método de pago',
      enterprise: { title: '¿Necesitas más?', body: 'Los equipos más grandes y las condiciones personalizadas se acuerdan con nuestro equipo.', cta: 'Contactar con ventas' },
      provisioning: 'Configurando: puede tardar un minuto.',
      provisioningFailed: 'La configuración falló: estamos en ello.',
      removeModule: 'Eliminar módulo', removeConfirmTitle: '¿Eliminar el módulo?',
      removeConfirmBody: '{module} se eliminará al final de tu ciclo de facturación actual. Puedes deshacerlo hasta entonces.',
      removeScheduled: 'Eliminación de {module} programada.',
      addTitle: 'Añadir un módulo', addSubtitle: 'Amplía tu espacio de trabajo con otro módulo.',
      addCta: 'Añadir módulo', addConfirmTitle: '¿Añadir el módulo?',
      moduleLabel: 'Módulo', planLabel: 'Plan',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Precio', seats: 'Plazas', monthly: 'Al mes', from: 'a partir del {date}' },
      apprenticeSeats: 'Plazas de aprendiz contratadas',
      apprenticeSeatsHint: 'Al menos 1 plaza de aprendiz para el módulo de formación.',
      apprenticeSeatsCeiling: 'Por encima de {max} plazas de aprendiz no hay tarifa de autoservicio: la acordamos directamente contigo:',
      apprenticeSeatAdjustment: 'Tenías reservadas {booked} plazas de aprendiz antes de que se eliminara este módulo, así que se ha vuelto a añadir con {booked} en lugar de las {requested} solicitadas. Puedes reducirlas a partir de tu próximo cargo.',
      added: '{module} añadido.',
      addedPaymentRetrying: '{module} se ha añadido y está listo para usar. No pudimos cobrar el pago en este momento: lo reintentaremos automáticamente.',
      alreadyActive: '{module} ya está en tu plan.',
    },
    seats: {
      title: 'Plazas contratadas',
      userSeats: 'Plazas de usuario', apprenticeSeats: 'Plazas de aprendiz',
      stepUp: 'Más plazas', stepDown: 'Menos plazas',
      bookMore: 'Contratar más plazas',
      confirmTitle: '¿Contratar más plazas?', confirmCta: 'Contratar plazas',
      chargeNote: 'Contratar más plazas implica un cargo prorrateado por el resto de este ciclo de facturación.',
      confirmTitleDecrease: '¿Reducir las plazas contratadas?',
      reduceCta: 'Reducir plazas',
      decreaseNote: 'Hoy no se cobra ni se abona nada: tu contratación cambia el {date}.',
      decreaseNoteImmediate: 'No se cobra ni se abona nada: tu contratación cambia de inmediato.',
      decreaseScheduled: 'Reducción de plazas programada para el {date}.',
      mixedDirection: 'Contrata más plazas y reduce plazas en pasos separados: las plazas añadidas se cobran hoy y las reducidas se aplican en tu próxima facturación.',
      belowUsage: 'Tu espacio de trabajo usa más plazas que eso. Mantén al menos {count}.',
      usageCheckUnavailable: 'No pudimos comprobar cuántas plazas están ocupadas ahora mismo. Inténtalo de nuevo en un momento.',
      leaveFreelancer: 'Con esto sales del modo freelance.',
      returnFreelancer: 'Con esto vuelves al modo freelance: una persona, una plaza.',
      booked: 'Tus plazas contratadas se han actualizado.',
      bookedPaymentRetrying: 'Tus plazas están contratadas y listas para usar. No pudimos cobrar el pago en este momento: lo reintentaremos automáticamente.',
      bookFailed: 'No se pudieron contratar las plazas. Inténtalo de nuevo.',
    },
    seatPanel: {
      inUse: '{used} de {booked} en uso',
      bookedOnly: '{booked} contratadas',
      useUnknown: 'No pudimos saber cuántas están en uso ahora mismo.',
      manage: 'Gestionar plazas',
      pendingUsers: 'Las plazas de usuario cambian a {target} el {date}; hasta entonces tienes {current} contratadas.',
      pendingApprentices: 'Las plazas de aprendiz cambian a {target} el {date}; hasta entonces tienes {current} contratadas.',
      reflooredUsers: 'Tu reducción a {requested} plazas de usuario se aplicó con {booked}: hay {used} personas en el espacio de trabajo y cada una ocupa una plaza. Quita a las que ya no necesites y vuelve a reducir.',
      reflooredApprentices: 'Tu reducción a {requested} plazas de aprendiz se aplicó con {booked}: hay {used} formaciones en curso. Finaliza las que ya no necesites y vuelve a reducir.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Los aprendices de los datos de demostración no ocupan puestos reservados: no se cuentan aquí y desaparecen cuando confirmas la demo.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Lo que cuesta esta reserva',
      includes: 'Lo que incluye tu reserva y lo que cuesta al mes.',
      userSeatsCount: '{count} puestos de usuario',
      apprenticeSeatsCount: '{count} puestos de aprendiz',
      aiQuotaUpgradesCount: '{count} × ampliación',
      subtotal: 'Subtotal',
      volumeDiscount: 'Descuento por volumen',
      monthlyTotal: 'Total mensual',
      currentTotal: 'Hoy pagas {amount} al mes.',
      newMonthlyTotal: 'Desde tu próxima factura: {amount} al mes.',
      netNote: 'Precios sin IVA. Reservar más puestos añade además un importe único prorrateado por el resto del ciclo de facturación actual.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'Cuota de IA',
      usageLink: 'En qué se usa',
      ownKey: 'Este espacio de trabajo usa lumi con su propia clave de proveedor de IA, así que no tiene cuota de IA: tu proveedor te factura directamente cada token.',
      suspended: 'La cuota de IA está en pausa mientras este espacio de trabajo esté suspendido.',
      unlimited: 'Este espacio de trabajo no tiene cuota de IA: lumi ha retirado el límite.',
      intro: 'lumi, las funciones de IA de todos los módulos y los agentes de IA externos que conectan los miembros comparten una sola cuota: hasta {limit} tokens por ciclo de facturación. Se restablece al comienzo de cada ciclo de facturación; los tokens no usados no se acumulan.',
      included: 'Incluida',
      includedDerived: 'con tus plazas contratadas',
      includedOverride: 'fijada por lumi para este espacio de trabajo',
      tokensValue: '{tokens} tokens por ciclo',
      upgrades: 'Ampliaciones de cuota',
      upgradesNone: 'Ninguna contratada',
      upgradesValue: 'Contratadas: {count} · +{tokens} tokens',
      used: 'Usado en este ciclo',
      usedValue: '{used} de {limit} tokens',
      usedNoLimit: '{used} tokens hasta ahora',
      resetsOn: 'Se restablece el {date}',
      stepPrice: 'Una ampliación añade {tokens} tokens por ciclo de facturación por {amount} al mes.',
      stepUp: 'Una ampliación más',
      stepDown: 'Una ampliación menos',
      removeCta: 'Retirar en la próxima fecha de facturación',
      confirmTitle: '¿Añadir una ampliación de la cuota de IA?',
      confirmTitleDecrease: '¿Retirar una ampliación de la cuota de IA?',
      confirmCta: 'Contratar ampliación',
      trialWarning: 'Esto cuesta dinero real, también durante tu prueba: hoy se carga en tu tarjeta la parte proporcional del resto de la prueba, con un máximo de un mes, y después, cada mes.',
      cardRequired: 'Para ampliar la cuota de IA necesitas una tarjeta activa, también durante la prueba. Añade primero tu tarjeta; en cuanto esté confirmada podrás contratar la ampliación.',
      promoExcluded: 'Tu código no se aplica a la cuota de IA: una ampliación nunca se descuenta y se cobra al precio de lista.',
      chargeNote: 'Una ampliación implica un cargo prorrateado por el resto de este ciclo de facturación y se aplica de inmediato.',
      decreaseNote: 'Hoy no se cobra ni se abona nada. Conservas la ampliación hasta el {date}; a partir de entonces se aplica la cuota menor.',
      decreaseNoteGeneric: 'Hoy no se cobra ni se abona nada: la ampliación termina en tu próxima fecha de facturación.',
      newQuota: 'Después: hasta {limit} tokens por ciclo de facturación.',
      changeDelta: '{tokens} tokens · {amount} / mes',
      addCtaPrice: 'Añadir ampliación de cuota · {amount} / mes',
      booked: 'Tus ampliaciones de la cuota de IA se han actualizado.',
      bookedPaymentRetrying: 'Tu ampliación de la cuota de IA está contratada y se aplica de inmediato. No pudimos cobrar el pago en este momento: lo reintentaremos automáticamente.',
      decreaseScheduled: 'La ampliación de la cuota de IA termina el {date}.',
      pending: 'Las ampliaciones de cuota cambian a {target} el {date}; hasta entonces tienes {current} contratadas.',
      bookFailed: 'No se pudieron cambiar las ampliaciones de la cuota de IA. Inténtalo de nuevo.',
    },
    scheduled: {
      resizeTo: 'Cambiar a {plan}', remove: 'Quitar módulo',
      effective: 'a partir del {date}', revert: 'Deshacer', reverted: 'Cambio programado revertido.',
    },
    proration: {
      title: 'Confirmar cambio de plan', stepFrom: 'Actual', stepTo: 'Nuevo',
      chargeNote: 'Mejorar ahora implica un cargo prorrateado por el resto de este ciclo de facturación.',
      freeNote: 'Este cambio se aplica de inmediato sin coste adicional durante tu prueba.',
      confirm: 'Confirmar y mejorar', cancel: 'Cancelar',
      charged: 'Se ha cobrado {amount}.', appliedImmediate: 'Tu nuevo plan está activo.',
      appliedScheduled: 'Programado: a partir del {date}.',
      calculating: 'Calculando el importe exacto…',
      chargeExact: 'Hoy se te cobrarán {amount}.',
      noChargeToday: 'Hoy no se cobra nada.',
    },
    profile: {
      title: 'Datos de facturación', subtitle: 'Completa tus datos de facturación para activar el pago.',
      legalName: 'Razón social', addressLine1: 'Dirección', addressLine2: 'Línea de dirección 2',
      postalCode: 'Código postal', city: 'Ciudad', vatId: 'NIF-IVA',
      vatOptional: 'Opcional: obligatorio para la inversión del sujeto pasivo dentro de la UE.',
      save: 'Guardar datos', edit: 'Editar datos de facturación', error: 'No se pudieron guardar tus datos de facturación.',
      saved: 'Datos de facturación guardados.',
      vatPending: 'No hemos podido verificar tu NIF-IVA en este momento. Inténtalo de nuevo en breve.',
      vatInvalid: 'No se ha podido validar este NIF-IVA. Compruébalo.',
      vatRequired: 'Se requiere un NIF-IVA válido para tu país antes de añadir una tarjeta.',
      completeFirst: 'Completa tus datos de facturación antes de añadir una tarjeta.',
    },
    cancel: {
      title: 'Cancelar suscripción',
      body: 'Cancela tu suscripción. Tu espacio de trabajo seguirá activo hasta el final del ciclo de facturación actual.',
      reason: 'Motivo (opcional)', confirm: 'Cancelar suscripción', confirmTitle: '¿Cancelar la suscripción?',
      confirmBody: 'Tu suscripción termina el {date}. Hasta entonces todo sigue funcionando.',
      note: 'Hasta entonces todo sigue funcionando, incluida la exportación de todo el espacio de trabajo. Después, el espacio de trabajo se cierra; sus datos se conservan durante un tiempo y los propietarios reciben un aviso antes de que se elimine nada. Si debe desaparecer antes, usa «{deletion}».',
      pending: 'Cancelación programada: tu suscripción termina el {date}.', pendingNoDate: 'Cancelación programada.',
      revert: 'Mantener suscripción', error: 'No se pudo cancelar tu suscripción.',
      done: 'Cancelación programada. Tu espacio de trabajo sigue activo hasta el final del ciclo de facturación actual.', revertDone: 'Cancelación revertida. Tu suscripción continúa con normalidad.',
    },
    deletion: {
      title: 'Eliminar espacio de trabajo (RGPD)',
      body: 'Solicita la eliminación permanente de este espacio de trabajo y de todos sus datos. Tras un breve período de gracia, esto no se puede deshacer.',
      request: 'Solicitar eliminación', reason: 'Motivo (opcional)',
      confirmTitle: '¿Solicitar la eliminación del espacio de trabajo?',
      confirmBody: 'Todos los datos se borrarán de forma permanente tras un breve período de gracia. Esto no se puede deshacer.',
      pending: 'Eliminación solicitada: los datos se borran después del {date}.', pendingNoDate: 'Eliminación solicitada y pendiente de revisión.',
      cancel: 'Cancelar solicitud de eliminación', error: 'No se pudo enviar tu solicitud de eliminación.',
      requested: 'Eliminación solicitada. Borraremos tu espacio de trabajo tras el período de gracia.', canceled: 'Solicitud de eliminación retirada. Tu espacio de trabajo se conserva.',
      confirmType: 'Escribe el nombre del espacio de trabajo ({name}) para confirmar',
      cancelConfirmTitle: '¿Retirar la solicitud de eliminación?',
      cancelConfirmBody: 'Tu espacio de trabajo y todos sus datos se conservan. Puedes volver a solicitar la eliminación cuando quieras.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Reclutamiento', time_tracking: 'Tiempo', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Por usuario', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Por usuario', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Por aprendiz', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Por usuario', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Ampliación de la cuota de IA (+1.000.000 tokens por ciclo de facturación)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Este espacio de trabajo está exento de facturación', body: 'lumi ha acordado que este espacio de trabajo no se factura, así que no tiene cuenta de facturación y no se te cobra ni se te cobrará nada. Solo lumi puede cambiarlo; aquí no hay nada que configurar.' },
      demo: { title: 'La facturación no está disponible en modo demo', body: 'Este espacio de trabajo funciona con datos de demostración, así que todavía no hay nada que facturar. La facturación se podrá configurar en cuanto conviertas la demo en una configuración real: el banner de demostración de la parte superior de la página lo inicia.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'La configuración de la facturación no se completó', buyerBody: 'Tu registro no se completó, por lo que este espacio de trabajo aún no tiene cuenta de facturación y no se está cobrando nada. Puedes terminarlo tú mismo: vuelve al pago y contrata los mismos módulos otra vez; así se retoma este espacio de trabajo en lugar de crear un segundo. Si aun así no sale, escríbenos y lo terminamos contigo.', otherBody: 'Tu registro no se completó, por lo que este espacio de trabajo aún no tiene cuenta de facturación y no se está cobrando nada. Solo la persona que registró este espacio de trabajo puede terminarlo, volviendo al pago y contratando los mismos módulos otra vez. Pídeselo, o escríbenos y lo terminamos contigo.', checkoutCta: 'Volver al pago', cta: 'Contactar con soporte' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Documentos contractuales',
      terms: 'Términos y condiciones',
      avv: 'Acuerdo de tratamiento de datos (AVV)',
      tom: 'Medidas técnicas y organizativas (TOM)',
      subprocessors: 'Subencargados del tratamiento',
    },
  },
  login: {
    ssoApple: 'Iniciar sesión con Apple',
    passkeySignIn: 'Acceder con una clave de acceso',
    passkeySigningIn: 'Accediendo…',
    passkeyFailed: 'El acceso con clave de acceso ha fallado. Inténtalo de nuevo o usa tu contraseña.',
    title: 'lumi-HR Suite',
    subtitle: 'Inicia sesión para continuar',
    email: 'Correo electrónico',
    emailPlaceholder: "nombre{'@'}empresa.es",
    password: 'Contraseña',
    passwordPlaceholder: 'Tu contraseña',
    signIn: 'Iniciar sesión',
    signingIn: 'Iniciando sesión…',
    failed: 'Error de inicio de sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    lostPhone: '¿Has perdido tu móvil?',
    orContinueWith: 'o continúa con',
    ssoGoogle: 'Iniciar sesión con Google',
    ssoMicrosoft: 'Iniciar sesión con Microsoft',
    ssoEnterprise: 'Iniciar sesión con el SSO de la empresa',
    ssoOnly: 'El inicio de sesión en este espacio de trabajo se realiza a través del SSO de tu empresa.',
    adminLogin: 'Inicio de sesión de administrador',
    ssoError: 'El inicio de sesión SSO falló. Inténtalo de nuevo.',
    ssoSeatLimit: 'Este workspace no tiene ninguna plaza de usuario libre, así que no pudimos crear una cuenta para ti. Pide al propietario del workspace o a un Billing Manager que contrate otra plaza: volver a intentarlo no servirá hasta entonces.',
    ssoLinkRequired: 'No se ha podido vincular automáticamente este inicio de sesión de empresa con tu cuenta de lumi. Inicia sesión de otra forma y vincula el inicio de sesión de empresa en Cuenta y seguridad.',
    ssoEmployeeNoticeIncomplete: 'Este workspace todavía no está listo: los avisos para empleados todavía tienen campos por rellenar. Pide a la persona propietaria del workspace, a una administración de suite o a la persona delegada de protección de datos que los complete en la sección Avisos legales — volver a intentarlo no servirá hasta entonces.',
    ssoLegalReadinessUnavailable: 'No hemos podido comprobar si este workspace está listo en este momento. Inténtalo de nuevo en unos minutos.',
    ssoOperatorPasswordOnly: 'Las cuentas de administrador del sistema inician sesión con su contraseña y su aplicación de autenticación, no con este proveedor.',
    mfaTitle: 'Introduce tu código de autenticación',
    mfaIntro: 'Esta es una cuenta de administrador del sistema. Introduce el código de 6 dígitos de tu aplicación de autenticación o uno de tus códigos de recuperación.',
    mfaCode: 'Código',
    mfaSubmit: 'Iniciar sesión',
    mfaBack: 'Volver',
    mfaInvalid: 'Ese código no es correcto.',
    mfaReused: 'Ese código ya se ha usado. Espera al siguiente en tu aplicación.',
    mfaExpired: 'Este inicio de sesión ha caducado. Vuelve a iniciar sesión con tu contraseña.',
    mfaEnrolOnConsole: 'Esta cuenta de administrador del sistema aún no tiene una aplicación de autenticación. Configúrala primero iniciando sesión en la consola de lumi.',
    tenantLogoAlt: 'Logotipo del espacio de trabajo',
    poweredBy: 'Con la tecnología de',
  },
  loginBranding: {
    nav: 'Página de inicio de sesión',
    title: 'Página de inicio de sesión',
    intro: 'Dale a la página de inicio de sesión de este espacio de trabajo tu propio logotipo, color e imagen de fondo. La ve todo el mundo que inicia sesión aquí.',
    retry: 'Reintentar',
    loadFailed: 'No se pudieron cargar los ajustes actuales.',
    form: {
      title: 'Apariencia',
      logo: 'Logotipo',
      logoHint: 'PNG, JPEG, WebP o GIF, hasta 2 MB. Déjalo vacío para conservar el logotipo de lumi.',
      image: 'Imagen de fondo',
      imageHint: 'Se muestra detrás de la tarjeta de acceso. PNG, JPEG, WebP o GIF, hasta 8 MB.',
      upload: 'Subir',
      replace: 'Reemplazar',
      remove: 'Quitar',
      empty: 'Sin imagen',
      uploaded: 'Imagen subida.',
      removed: 'Imagen eliminada.',
      tooLarge: 'Ese archivo es demasiado grande.',
      wrongType: 'Solo se aceptan imágenes PNG, JPEG, WebP y GIF.',
      uploadFailed: 'No se ha podido subir la imagen. Inténtalo de nuevo.',
      removeFailed: 'No se ha podido eliminar la imagen. Inténtalo de nuevo.',
      removeConfirm: 'La imagen se quita de la página de inicio de sesión y se elimina. No se puede deshacer.',
      primaryColor: 'Color principal',
      colorPlaceholder: 'p. ej. 1a2b3c',
      colorInvalid: 'Introduce un color hexadecimal como 1a2b3c.',
      clear: 'Borrar',
      save: 'Guardar',
      saved: 'Página de inicio de sesión actualizada.',
      discard: 'Descartar',
      liveNote: 'Los cambios guardados se ven la próxima vez que se abra la página de inicio de sesión.',
    },
    preview: {
      title: 'Vista previa',
      hint: 'Así se ve la página de inicio de sesión con los valores de arriba.',
      logoAlt: 'Vista previa del logotipo',
    },
  },
  authFlow: {
    forgot: {
      title: 'Restablece tu contraseña',
      subtitle: 'Te enviaremos un enlace para restablecerla.',
      email: 'Correo electrónico',
      submit: 'Enviar enlace',
      done: 'Si existe una cuenta con ese correo electrónico, hemos enviado un enlace de restablecimiento.',
      backToLogin: 'Volver al inicio de sesión',
    },
    reset: {
      title: 'Establece una nueva contraseña',
      password: 'Nueva contraseña',
      confirm: 'Confirmar contraseña',
      submit: 'Guardar contraseña',
      success: 'Tu contraseña se ha cambiado. Ya puedes iniciar sesión.',
      goToLogin: 'Ir al inicio de sesión',
      invalid: 'Este enlace no es válido o ha caducado.',
      mismatch: 'Las contraseñas no coinciden.',
      tooShort: 'La contraseña debe tener al menos 8 caracteres.',
      missingToken: 'No se encontró ningún token válido.',
    },
    invite: {
      title: 'Configura tu cuenta',
      subtitle: 'Elige una contraseña para activar tu cuenta.',
      forTenant: 'Invitación a {tenant}',
      password: 'Contraseña',
      confirm: 'Confirmar contraseña',
      submit: 'Activar cuenta',
      submitting: 'Activando…',
      invalid: 'Esta invitación no es válida o ha caducado.',
      mismatch: 'Las contraseñas no coinciden.',
      tooShort: 'La contraseña debe tener al menos 8 caracteres.',
      passkey: {
        title: 'Configura tu acceso',
        intro: 'Accedes a lumi con una clave de acceso: huella, cara o PIN del dispositivo. Ninguna contraseña que recordar.',
        sentTo: 'Enviado a {phone}',
        create: 'Crear una clave de acceso',
        creating: 'Esperando a tu dispositivo…',
        instead: 'Usar una clave de acceso en su lugar',
        or: 'o',
        unsupported: 'Este navegador no puede crear una clave de acceso. Abre el enlace en tu móvil o en un navegador actualizado.',
        unavailable: 'Las claves de acceso no están disponibles aquí para este espacio de trabajo. Ponte en contacto con tu administrador.',
        expired: 'Ha tardado demasiado. Inténtalo de nuevo.',
        alreadyRegistered: 'Este dispositivo ya tiene una clave de acceso para lumi.',
        failed: 'No se ha podido crear la clave de acceso. Inténtalo de nuevo.',
      },
    },
    recover: {
      title: '¿Has perdido tu móvil?',
      subtitle: 'Introduce tu número de móvil y te enviaremos por SMS un enlace para configurar una nueva clave de acceso.',
      phone: 'Número de móvil',
      phoneHint: 'Con el prefijo del país, p. ej. +34 612 345 678',
      submit: 'Enviar enlace',
      done: 'Si este número pertenece a una cuenta de aquí, le hemos enviado un enlace. Es válido durante 15 minutos.',
      enrolTitle: 'Configura una nueva clave de acceso',
      enrolSubtitle: 'Crea una clave de acceso en este dispositivo. Se cerrarán todas las demás sesiones de tu cuenta.',
      create: 'Crear una nueva clave de acceso',
      invalid: 'Este enlace no es válido o ha caducado. Solicita uno nuevo.',
    },
    verify: {
      verifying: 'Confirmando tu correo electrónico…',
      success: 'Tu dirección de correo electrónico se ha confirmado.',
      invalid: 'Este enlace de confirmación no es válido o ha caducado.',
      backToLogin: 'Ir al inicio de sesión',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Conexiones de agentes de IA',
      hint: 'Clientes de IA a los que ha permitido actuar en su nombre en un espacio de trabajo. Cada uno trabaja exactamente con sus permisos, y lo que lee se envía al proveedor de ese cliente.',
      none: 'No hay ningún agente de IA conectado.',
      inWorkspace: 'en el espacio de trabajo {workspace}',
      scope: {
        read: 'leer',
        act: 'actuar con confirmación',
        ask: 'preguntar a lumi',
      },
      lastUsed: 'Último uso el {when}',
      connectedOn: 'Conectado el {when}, aún sin usar',
      standing: {
        label: 'Realizar acciones sobre mis propios registros sin preguntar',
        hint: 'Nunca cubre registros de otras personas ni decisiones desfavorables.',
        notOffered: 'Esta conexión no admite un consentimiento permanente.',
        failed: 'No se pudo cambiar el ajuste. Inténtelo de nuevo.',
      },
      rolePins: {
        notHeld: 'Ya no tiene ese rol en este módulo.',
        failed: 'No se pudo cambiar el rol. Inténtelo de nuevo.',
      },
      disconnect: 'Desconectar',
      disconnectConfirm: '«{client}» pierde de inmediato el acceso a {workspace}. Para volver a usarlo, conéctelo de nuevo desde el cliente.',
      disconnected: '{client} desconectado.',
      disconnectFailed: 'No se pudo terminar la conexión. Inténtelo de nuevo.',
    },
    passkeys: {
      removeConfirm: 'Se quitará esta clave de acceso. El dispositivo que la usa ya no podrá iniciar sesión con ella.',
      title: 'Claves de acceso',
      hint: 'Una clave de acceso te identifica con tu dispositivo: huella, cara o PIN. Nada que recordar y nada que se pueda robar por phishing.',
      none: 'Aún no hay claves de acceso.',
      add: 'Añadir una clave de acceso',
      remove: 'Quitar',
      unnamed: 'Clave de acceso',
      lastUsed: 'Último uso el {when}',
      neverUsed: 'Sin usar',
      added: 'Clave de acceso añadida.',
      removed: 'Clave de acceso eliminada.',
      addFailed: 'No se ha podido añadir la clave de acceso. Inténtalo de nuevo.',
      removeFailed: 'No se ha podido eliminar la clave de acceso. Inténtalo de nuevo.',
      alreadyRegistered: 'Este dispositivo ya tiene una clave de acceso para lumi.',
      lastMethod: 'No puedes quitar tu única forma de acceder. Establece antes una contraseña o añade otra clave de acceso.',
      lostDevice: '¿Has perdido un móvil u otro dispositivo? Quita su clave de acceso de esta lista: es lo que le cierra el acceso a tu cuenta.',
    },
    currentPassword: 'Contraseña actual',
    phone: {
      title: 'Número de acceso',
      hint: 'Tu cuenta accede con una clave de acceso. Este número recibe tus enlaces de invitación y de recuperación.',
    },
    email: {
      title: 'Dirección de acceso',
      hint: 'La dirección con la que accedes. Cambiarla también cambia la dirección que tus espacios de trabajo muestran de ti.',
      newLabel: 'Nueva dirección',
      submit: 'Solicitar cambio',
      pending: 'Esperando confirmación en {email}. Sigue el enlace que hemos enviado allí.',
      cancel: 'Cancelar este cambio',
      cancelled: 'El cambio de dirección pendiente se ha cancelado.',
      sent: 'Consulta el nuevo buzón. No cambia nada hasta que sigas el enlace.',
      refused: 'Esa dirección no puede usarse en esta cuenta. Uno de tus espacios de trabajo limita las direcciones de acceso a sus propios dominios.',
      failed: 'No se ha podido solicitar el cambio. Inténtalo de nuevo.',
      ssoManaged: 'Tu dirección de acceso la gestiona tu proveedor de identidad.',
    },
    password: {
      title: 'Contraseña',
      hint: 'Cambiar la contraseña cierra tu sesión en todos los demás dispositivos.',
      newLabel: 'Nueva contraseña',
      confirmLabel: 'Repite la nueva contraseña',
      submit: 'Cambiar contraseña',
      changed: 'Tu contraseña se ha cambiado. Se ha cerrado la sesión en los demás dispositivos.',
      wrongCurrent: 'La contraseña actual no es correcta.',
      failed: 'No se ha podido cambiar la contraseña. Inténtalo de nuevo.',
      tooShort: 'La nueva contraseña debe tener al menos 8 caracteres.',
      mismatch: 'Las dos contraseñas nuevas no coinciden.',
      ssoOnly: 'Esta cuenta accede a través de tu proveedor de identidad, así que no tiene contraseña. Puedes añadir una como alternativa: te enviaremos un enlace.',
      sendLink: 'Enviarme un enlace para establecer una contraseña',
      linkSent: 'Si se puede establecer una contraseña para esta cuenta, el enlace va de camino.',
      linkFailed: 'No se ha podido enviar la solicitud. Inténtalo de nuevo.',
    },
    confirmEmail: {
      title: 'Confirma tu nueva dirección',
      working: 'Confirmando…',
      success: 'Tu dirección de acceso se ha cambiado. Vuelve a acceder con la nueva dirección.',
      goToLogin: 'Ir al acceso',
      backToAccount: 'Volver a Cuenta y seguridad',
      missingToken: 'Este enlace está incompleto. Ábrelo directamente desde el correo.',
      invalid: 'Este enlace de confirmación no es válido o ha caducado.',
      unavailable: 'Este cambio ya no se puede aplicar. Vuelve a solicitarlo.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Cancelar el cambio de dirección',
      working: 'Cancelando…',
      success: 'El cambio se ha cancelado. Sigues accediendo con tu dirección actual.',
      goToLogin: 'Ir al acceso',
      missingToken: 'Este enlace está incompleto. Ábrelo directamente desde el correo.',
      invalid: 'Este enlace no es válido o ha caducado: ya no hay ningún cambio que cancelar.',
    },
    title: 'Cuenta y seguridad',
    identities: 'Métodos de inicio de sesión vinculados',
    noIdentities: 'No hay métodos de inicio de sesión externos vinculados.',
    unlink: 'Quitar',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Se quitará este método de inicio de sesión. Ya no podrás iniciar sesión en tu cuenta con él.',
    linkGoogle: 'Vincular Google',
    linkMicrosoft: 'Vincular Microsoft',
    linkApple: 'Vincular Apple',
    lastMethod: 'No puedes quitar tu único método de inicio de sesión. Establece primero una contraseña.',
    linked: 'Método de inicio de sesión vinculado.',
    unlinked: 'Método de inicio de sesión eliminado.',
    linkFailed: 'Error al vincular.',
  },
  workspace: {
    title: 'Espacio de trabajo',
    subtitle: 'Selecciona un tenant y un módulo',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Cambiar a modo oscuro',
    themeLight: 'Cambiar a modo claro',
    welcomeTitle: 'Bienvenido al espacio de trabajo',
    welcomeSubtitle:
      'Selecciona tu tenant y un módulo de aplicación para empezar.',
    availableModules: 'Módulos disponibles',
    comingSoonSection: 'Próximamente en lumi-HR',
    adminMode: 'Modo administrador',
    aiUsage: {
      title: 'Uso de IA',
      pageIntro: 'Si lumi está disponible en este espacio de trabajo y lo que ha consumido la IA este mes.',
      loading: 'Cargando uso…',
      remaining: '{n} restantes',
      periodLabel: 'Ciclo de facturación',
      historyTitle: 'Ciclos de facturación',
      usedThisPeriod: 'Usado en este ciclo de facturación',
      split: '{included} incluidos · +{upgrades} por ampliaciones de cuota',
      resetsOn: 'Se restablece el {date}',
      periodFrom: 'Ciclo de facturación desde el {date}',
      nearLimit: 'La cuota de IA de este ciclo de facturación está casi agotada. Una ampliación de cuota en Facturación la aumenta de inmediato.',
      unlimited: 'Este espacio de trabajo no tiene cuota de IA.',
      ownKey: 'Este espacio de trabajo usa lumi con su propia clave de proveedor de IA, así que no tiene cuota de IA.',
      noUsageYet: 'Todavía no hay uso de IA en este ciclo de facturación.',
      upgradeLink: 'Añadir una ampliación de cuota en Facturación',
      modules: {
        ats: 'Reclutamiento',
        time: 'Tiempo',
        time_tracking: 'Tiempo',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'Asistente lumi',
        mcp: 'Agentes externos',
      },
    },
    active: 'Activo',
    systemAdmin: 'Administrador del sistema',
    user: 'Usuario',
    admin: 'Administración',
    comingSoon: 'Próximamente',
    noTenants: 'No hay tenants disponibles',
    createViaCheckout: 'Crear un espacio de trabajo desde la página de pago',
    loadFailed: 'No se pudieron cargar los tenants',
    planKlein: 'Pequeño',
    planMedium: 'Mediano',
    planEnterprise: 'Empresa',
    retry: 'Reintentar',
    logout: 'Cerrar sesión',
    noAccess: 'Sin acceso',
  },
  support: {
    title: 'Solicitudes de soporte',
    myTickets: 'Mis solicitudes',
    myTicketsTitle: 'Mis solicitudes de soporte',
    inbox: 'Bandeja de entrada',
    inboxTitle: 'Bandeja de soporte',
    inboxSubtitle: 'Tickets de los tenants que atiendes',
    ticket: 'Ticket',
    newTicket: 'Nueva solicitud de soporte',
    newTicketTitle: 'Nueva solicitud de soporte',
    newTicketIntro: 'Describe tu problema y te responderemos.',
    sent: 'Tu solicitud se ha enviado.',
    goToMyRequests: 'Ir a mis solicitudes de soporte',
    subject: 'Asunto',
    subjectPlaceholder: 'Breve resumen',
    message: 'Mensaje',
    messagePlaceholder: 'Describe qué ha ocurrido…',
    consentLabel: 'Reconozco que mis datos se procesan para gestionar esta solicitud',
    send: 'Enviar',
    reply: 'Responder',
    markComplete: 'Marcar como resuelto',
    reopen: 'Reabrir',
    replyPlaceholder: 'Escribe una respuesta…',
    escalate: 'Escalar',
    escalated: 'Escalado',
    deescalate: 'Desescalar',
    deescalateBlocked: 'Este ticket aún tiene un acceso de soporte abierto. Revócalo primero y luego desescala.',
    close: 'Cerrar',
    statusLabel: 'Estado',
    module: 'Módulo',
    tenant: 'Tenant',
    requester: 'Solicitante',
    updated: 'Actualizado',
    backToTickets: 'Volver a mis solicitudes',
    status: {
      open: 'Abierto',
      in_progress: 'En curso',
      answer: 'Respondido',
      closed: 'Cerrado',
    },
    author: {
      user: 'Tú',
      support: 'Soporte',
      systemAdmin: 'Administrador del sistema',
    },
    empty: {
      myTitle: 'Aún no hay tickets',
      myBody: 'Cuando crees un ticket de soporte, aparecerá aquí.',
      inboxTitle: 'Nada que atender',
      inboxBody: 'No tienes tickets de soporte en tus tenants en este momento.',
      notFoundTitle: 'Ticket no disponible',
      notFoundBody: 'No se pudo cargar este ticket. Puede que se haya eliminado o que no tengas acceso.',
    },
  },
  notifications: {
    nav: 'Notificaciones',
    title: 'Notificaciones',
    subtitle: 'Cosas que requieren tu atención.',
    settings: 'Ajustes',
    backToWorkspace: 'Volver al espacio de trabajo',
    area: 'Área',
    areaAll: 'Todas las áreas',
    status: 'Estado',
    statusAll: 'Todas',
    statusUnread: 'No leídas',
    statusRead: 'Leídas',
    perPage: 'Por página',
    markRead: 'Marcar como leída',
    markUnread: 'Marcar como no leída',
    markAllRead: 'Marcar todas como leídas',
    loading: 'Cargando…',
    empty: 'Estás al día.',
    pageInfo: '{from}–{to} de {total}',
    prev: 'Anterior',
    next: 'Siguiente',
    retentionHint: 'Las notificaciones se conservan durante 6 meses.',
    settingsTitle: 'Configurar notificaciones por área',
    settingsSubtitle: 'Elige cómo quieres recibir notificaciones en cada área.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Algunos avisos sobre seguridad, dinero, contratos, tu espacio de trabajo y plazos legales siempre llegan a quienes les conciernen — también aparecen en la campana.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Tu cuenta no tiene dirección de correo, así que los avisos te llegan en la app (y como notificación push donde la hayas permitido). Por eso «{mailMode}» funciona como «{inAppMode}»: no se envía nada por correo.',
    mustReachStillReaches: 'Incluso si lo desactivas, seguirás recibiendo {list} cuando te conciernan.',
    mandatoryReason: {
      billing: 'No se puede desactivar: el dinero que debes tiene que llegar a la persona responsable.',
      legal: 'No se puede desactivar: los cambios contractuales deben llegarte, como prometen nuestras condiciones.',
    },
    mustReachFamily: {
      identity: 'avisos de seguridad',
      money: 'avisos de facturación',
      legal: 'avisos contractuales',
      workspace: 'avisos sobre el estado del espacio de trabajo',
      privacy: 'recordatorios de plazos de privacidad',
      participation: 'solicitudes a la representación de los empleados',
    },
    backToList: 'Volver a las notificaciones',
    modeOff: 'Nada',
    modeInApp: 'Solo en la app',
    modeMailInApp: 'Correo y en la app',
    saved: 'Guardado.',
    saveError: 'No se ha podido guardar. El ajuste se ha restablecido.',
    openTarget: 'Abrir el elemento vinculado',
    opening: 'Abriendo…',
    openFailed: 'No se pudo abrir esa notificación.',
    areas: {
      system: 'Sistema',
      timecard: 'Tiempo',
      ats: 'Reclutamiento',
      apprentice: 'Ausbildung',
      people: 'Personal',
      support: 'Soporte',
      postings: 'Ofertas de empleo',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Facturación',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Documentos contractuales',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Guardar mis datos',
      later: 'Más tarde',
      saved: 'Gracias: tus datos están guardados.',
      skip: {
        title: '¿Omitir tus datos?',
        body: 'Mientras no rellenes tus datos, tu ficha seguirá sin confirmar en Personal. Eso significa: no se pueden añadir datos de empleado como contrato, vacaciones o nómina, no puedes figurar como responsable de nadie y apareces como «sin confirmar» en Personal. Puedes completarlos cuando quieras; este aviso volverá mañana.',
        fill: 'Rellenar ahora',
        skip: 'Omitir por ahora',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'Configurar lumi',
      subtitle: 'Nada de esto es obligatorio. Todo merece la pena cuando llegues a ello.',
      hide: 'Ya no lo necesito',
      viewAll: 'Ver todo lo que lumi puede hacer',
      rareHeading: 'Se usa con menos frecuencia',
      page: {
        title: 'Lo que lumi puede hacer.',
        subtitle: 'Todo lo que se puede configurar. Lo más importante primero, el resto cuando lo necesites.',
        tipsTitle: 'Consejos en la página de inicio',
        tipsShown: 'El panel aparece arriba en tu página de inicio hasta que ya no lo necesites.',
        tipsHidden: 'Has ocultado el panel. Aquí lo recuperas.',
        emptyTitle: 'Aquí no hay nada que configurar para ti.',
        emptyBody: 'Lo que se puede configurar lo gestionan los responsables de tu equipo. Habla con ellos si te falta algo.',
      },
      sections: {
        suite: 'Inicio',
        ats: 'Reclutamiento',
        time: 'Tiempo',
        people: 'Personal',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Personaliza la página de inicio de sesión', hint: 'Logotipo y colores, para que tu equipo vea que está en el sitio correcto.' },
        portal_design: { title: 'Personaliza el portal de empleo', hint: 'Así ve tu empresa quien se postula por primera vez.' },
        email_templates: { title: 'Plantillas de correo', hint: 'Confirmación, invitación, rechazo: se escribe una vez y se usa siempre.' },
        job_posting_settings: { title: 'Datos para las ofertas de empleo', hint: 'Logotipo y persona de contacto. Los portales externos necesitan ambos.' },
        work_time_models: { title: 'Modelos de jornada', hint: 'Quién trabaja cuántas horas y qué días.' },
        company_holidays: { title: 'Cierres de la empresa', hint: 'Días en los que la empresa está cerrada.' },
        data_import: { title: 'Importar personas', hint: 'Trae tus listas existentes en lugar de escribirlo todo.' },
        company_profile: { title: 'Perfil de la empresa', hint: 'Dirección y datos básicos que lumi usa en muchos sitios.' },
        org_units: { title: 'Unidades organizativas', hint: 'Departamentos y sedes por los que se ordena casi todo.' },
        payroll_handover: { title: 'Entrega de nómina (DATEV)', hint: 'lumi entrega las horas, tu asesor fiscal calcula la nómina.' },
        training_occupations: { title: 'Profesiones de formación', hint: 'Qué profesiones formáis.' },
        workflows: { title: 'Workflows', hint: 'Pasos y aprobaciones propios en el proceso de selección.' },
        application_forms: { title: 'Formularios de solicitud', hint: 'Qué preguntas responden los candidatos.' },
        offer_templates: { title: 'Plantillas de oferta', hint: 'Preparar ofertas de contrato con marcadores.' },
        custom_fields: { title: 'Campos personalizados', hint: 'Datos adicionales en vacantes y candidaturas.' },
        booking_types: { title: 'Tipos de registro', hint: 'Qué se puede registrar además del tiempo de trabajo.' },
        leave_types: { title: 'Tipos de ausencia', hint: 'Vacaciones, enfermedad y vuestros propios tipos.' },
        api_settings: { title: 'Interfaz (API)', hint: 'Pasar los tiempos a tus propios programas por la API. La entrega de nómina está en Personal.' },
        time_clock: { title: 'Reloj de fichaje', hint: 'Abrirlo en el navegador de una tableta en el centro de trabajo: cada persona inicia sesión con su propio acceso a lumi y ficha.' },
        sso: { title: 'Single Sign-on', hint: 'Inicio de sesión con la cuenta de vuestra empresa.' },
        onboarding_templates: { title: 'Plantillas de incorporación', hint: 'Listas de tareas para los primeros días de las nuevas incorporaciones.' },
        recruiting_options: { title: 'Listas de opciones', hint: 'Tratamientos, tipos de contrato y lugares de trabajo entre los que elige vuestro equipo.' },
      },
    },
    greeting: { morning: 'Buenos días', day: 'Hola', evening: 'Buenas noches' },
    // La línea de fecha bajo el saludo ("Lunes, 21 de septiembre · Semana 39",
    // workspace-start M2) sustituye al subtítulo estático.
    dateLine: { week: 'Semana {n}' },
    open: 'Abrir',
    recents: 'Recientes',
    recentKinds: { report: 'Informe semanal', job: 'Puesto', application: 'Candidatura' },
    moreActions: 'Más acciones',
    clockedInSince: 'Fichado desde las {time}',
    clockedOut: 'Sin fichar',
    clockOut: 'Fichar salida',
    clockIn: 'Fichar entrada',
    projectRunning: 'Tiempo de proyecto en curso',
    projectRunningSince: 'Desde las {time}',
    startProject: 'Iniciar un proyecto',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Según tu contrato, solo registras tiempo de proyecto, no tiempo de trabajo.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: '¿En qué estás trabajando?',
      none: 'Sin proyecto',
      noneSub: 'Cuenta como «Sin asignar»',
      choose: 'Elegir proyecto y actividad',
      fieldLabel: '¿En qué estás trabajando? Ahora: {current}',
      runningWith: '{activity} · desde las {time}',
      runningSince: 'Desde las {time}',
      activityStep: '¿Qué actividad?',
      back: 'Todos los proyectos',
      defaultActivity: 'Predeterminada',
      search: 'Buscar proyecto',
      noMatch: 'No se ha encontrado ningún proyecto',
      close: 'Cerrar',
    },
    provisioning: 'Configurando: puede tardar un minuto.',
    preferences: 'Preferencias',
    seeMyOrg: 'Mi organización',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Ofertas de empleo, candidaturas y el pipeline de selección: del primer CV al contrato firmado.',
        time_tracking: 'Fichajes, cuentas de tiempo de trabajo, ausencias y horas extra, listos para el registro horario.',
        apprenticeship: 'Libros de formación digitales, planes de formación y evaluaciones para cada aprendiz.',
      },
      heading: 'Más módulos',
    },
    empty: 'Aquí todavía no hay nada: abre el módulo para empezar.',
    unavailable: 'No se puede cargar en este momento.',

    goToModule: 'Ir a {module}', expand: 'Expandir {module}', collapse: 'Contraer {module}',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    people: { selfService: 'Mis datos' },
    myDocuments: {
      title: 'Mis documentos',
      downloadFailed: 'Error en la descarga – inténtalo de nuevo más tarde.',
      showAll: 'Mostrar todos ({count})',
      showLess: 'Mostrar menos',
      handIn: 'Entregar un documento',
      empty: 'Todavía no hay nada. Puedes entregar un certificado, una atestación, una baja médica o una copia de tu documento de identidad para tu expediente.',
      kindLabel: '¿De qué se trata?',
      fileLabel: 'Archivo – elegir o hacer una foto',
      send: 'Enviar',
      cancel: 'Cancelar',
      handedIn: 'Entregado el {date} · pendiente de RR. HH.',
      accepted: 'Entregado el {date} · aceptado',
      sentBack: 'Devuelto el {date}: «{reason}»',
      handInAgain: 'Entregar de nuevo',
      dismiss: 'Ocultar',
      error: {
        file_refused: 'No se pudo aceptar este archivo – prueba con otro archivo.',
        file_too_large: 'Este archivo es demasiado grande – el límite es de 25 MB.',
        file_empty: 'Este archivo está vacío – elige otro archivo.',
        file_missing: 'Elige primero un archivo.',
        quota_exceeded: 'Tu expediente ha alcanzado su límite de almacenamiento – contacta con RR. HH.',
        invalid_category: 'Elige de qué tipo de documento se trata.',
        not_possible: 'Ahora mismo no es posible entregar documentos – contacta con RR. HH.',
        generic: 'No se pudo entregar – inténtalo de nuevo más tarde.',
        scan_unavailable: 'No se pudo comprobar el archivo en este momento. Inténtalo de nuevo en un momento.',
      },
      category: {
        contract: 'Contrato de trabajo',
        contract_amendment: 'Modificación del contrato',
        certificate: 'Certificado de trabajo',
        attestation: 'Atestación',
        payslip: 'Nómina',
        health_certificate: 'Baja médica / certificado médico',
        identification: 'Documento de identidad',
        other: 'Otro',
      },
    },
    admin: {
      users: 'Usuarios',
      usersMoved: {
        title: 'La gestión de usuarios se ha trasladado a Personal',
        redirecting: 'Abriendo Personal…',
        noPeople: 'Quién tiene acceso a este espacio de trabajo se gestiona en cada persona dentro de Personal. Personal no está disponible para ti aquí: contacta con la persona propietaria del espacio de trabajo.',
      },
    },
    verwaltung: { heading: 'Administración' },
    nav: { home: 'Panel', billing: 'Facturación', logout: 'Cerrar sesión', language: 'Idioma', administration: 'Administración', sso: 'Single Sign-On', audit: 'Registro de auditoría', supportAccess: 'Acceso de soporte', aiUsage: 'Uso de IA', dataProcessing: 'Tratamiento de datos', dataRequests: 'Solicitudes de personas interesadas', legalNotices: 'Avisos legales', statutoryRules: 'Normas legales', trainingOccupations: 'Profesiones de formación', externalAgents: 'Agentes de IA externos', setup: 'Configurar' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Esta semana',
      hoursUnit: 'h',
      balance: 'Cuenta de horas a {date}: {balance}',
      balanceHint: 'Horas trabajadas menos horas a trabajar hasta ese día.',
      noTarget: 'No hay jornada semanal definida.',
      trustBased: 'Trabajas con tiempo de trabajo basado en la confianza: registras cuándo empiezas y cuándo terminas, y para ti no hay objetivo ni cuenta de horas.',
      projectsMore: 'y {n} más',
      days: 'Días de la semana',
    },
    heute: {
      clock: 'Fichaje',
      attention: 'Te necesita',
      news: 'Nuevo',
      leaveRemaining: 'Vacaciones restantes',
      days: 'Día | Días',
      kind: { interview: 'Entrevista', leave: 'Ausencias', holiday: 'Festivo', exam: 'Examen', station: 'Rotación' },
    },
    facts: {
      ats: { total_jobs: 'Vacantes', total_applications: 'Candidaturas', open_tasks: 'Tareas abiertas', new_applicants: 'Nuevos candidatos', create_job: 'Crear vacante', add_application: 'Añadir candidatura', create_task: 'Crear tarea', pipeline: 'Pipeline', pipeline_closed: '{n} cerradas', stage_other: 'Otras' },
      time: { week_hours: 'Horas esta semana', today_hours: 'Horas hoy', timesheet: 'Mi hoja de horas', request_leave: 'Solicitar ausencia', approvals: 'Aprobaciones', team: 'Equipo', pending_approvals: 'Aprobaciones pendientes', leave_remaining: 'Vacaciones restantes', proof_open: 'Falta justificante' },
      apprentice: { waiting: 'Por revisar', active: 'Aprendices', overdue: 'Semanas pendientes', this_week: 'Esta semana', badges: 'Habilidades', write: 'Registrar semana', skills: 'Muro de habilidades', review: 'Revisar informes', onboard: 'Añadir aprendiz', reports: 'Cuadernos de informes', report_approved: 'Aprobados', report_submitted: 'Por revisar', report_rejected: 'Devueltos', report_missing: 'Faltan' },
    },
  },
  preferences: {
    appearance: 'Apariencia',
    theme: 'Tema',
    themeHint: 'Interfaz clara u oscura.',
    language: 'Idioma',
    languageHint: 'El idioma usado en todo el espacio.',
    attributions: 'Atribuciones de datos abiertos',
    placesCredit: 'Datos de lugares © {source}, con licencia {licence}.',
    bankCodesCredit: "Códigos bancarios: fuente {bundesbank}; códigos bancarios austriacos © {oenb}, con licencia {licence}; códigos suizos y liechtensteinianos © {six}.",
    healthInsurersCredit: "Entidades de seguro médico: fichero maestro de la seguridad social del {gkv}.",
  },
  onboarding: {
    actions: { add: 'Añadir', back: 'Atrás', next: 'Siguiente', remove: 'Quitar' },
    modules: {
      ats: 'Reclutamiento',
      time_tracking: 'Tiempo',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Te damos la bienvenida a lumi',
      title: 'Qué bien que estés',
      titleMark: 'aquí.',
      subtitle: '¿Cómo quieres empezar? Puedes cambiar cuando quieras.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Salir de la demo',
      titleDemo: 'Ya has explorado bastante.',
      titleDemoMark: 'Ahora, de verdad.',
      subtitleDemo: 'Con la configuración guiada, la empresa de demostración se queda hasta que termines.',
      reassure: '¿No lo tienes claro? Empieza con la demo: pasarás a la configuración real cuando quieras.',
      seedFailed: 'La preparación de los datos de demostración no se completó. Inténtalo de nuevo.',
      seedFailedNotEmpty:
        'La demo necesita módulos vacíos, pero uno de los tuyos ya contiene datos. Elimínalos primero o elige «Configura tu suite».',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'La configuración no se puede completar hasta que aceptes el acuerdo de tratamiento de datos (AVV). Acéptalo aquí y volverás directamente a la guía de configuración.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Volver a la demo',
      demo: {
        eyebrow: 'Probar',
        title: 'Explorar con datos de demostración',
        body: 'Llenamos tus módulos con una empresa ficticia y coherente. Navega por todo sin miedo a romper nada.',
        modulesHint: 'Los módulos contratados siempre están incluidos.',
        cta: 'Explorar la demo',
      },
      guided: {
        eyebrow: 'Configurar',
        title: 'Guíame paso a paso',
        body: 'Paso a paso hasta tu suite real. Pausar, saltarte un paso o pasar antes por la demo: todo vale.',
        bodyDemo: 'Paso a paso hasta tu suite real. Si cierras la ventana, vuelves a la demo.',
        pointSaved: 'Tu progreso se guarda',
        pointOptional: 'Cada paso es opcional',
        cta: 'Guíame paso a paso',
      },
      empty: {
        eyebrow: 'Hazlo tú',
        titleFresh: 'Empezar en blanco',
        titleDemo: 'Descartar la demo y empezar en blanco',
        bodyFresh: 'Un lienzo en blanco. Lo vas configurando todo poco a poco, a tu ritmo.',
        bodyDemo: 'La empresa de demostración se elimina y empiezas desde una base vacía.',
        warnDemo: 'Esto ocurre al instante y no se puede deshacer.',
        cta: 'Empezar en blanco',
      },
    },
    exitGate: {
      title: 'Antes de salir de la demo',
      intro: 'Esto es lo que tiene contratado tu espacio de trabajo y cómo va tu periodo de prueba. Añade un módulo ahora o más tarde desde Facturación: la configuración funciona igual.',
      booked: { title: 'Contratado' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Compañeros invitados a la demo',
        lead: 'Estos compañeros pierden el acceso cuando termina la demo:',
        fallback: 'Los compañeros que invitaste a la demo pierden el acceso cuando termina.',
        people: 'Tu equipo real se invita desde Personal cuando tu espacio de trabajo esté configurado.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: 'Preparando {module}…',
        booked: '{module} está contratado y tiene su propia sección en la guía de configuración.',
        bookedPending: '{module} está contratado. Su sección aparecerá en la guía de configuración en cuanto el módulo esté listo.',
      },
      noManage: 'Solo el propietario del espacio de trabajo, un responsable de facturación o un administrador del espacio pueden contratar módulos. Puedes continuar sin contratar.',
      enforcement: 'Hay un pago pendiente en este espacio de trabajo. Las contrataciones quedan en pausa hasta que se resuelva; la configuración de tu suite, no.',
      factsUnavailable: 'No hemos podido cargar tu contratación ahora mismo. Puedes continuar igualmente; todo está en la página de Facturación.',
      trial: {
        title: 'Tu periodo de prueba',
        range: 'Tu periodo de prueba empezó el {start} y termina el {end}.',
        endOnly: 'Tu periodo de prueba termina el {end}.',
        rangeFree: 'Gratis del {start} al {end}.',
        endOnlyFree: 'Gratis hasta el {end}.',
        charge: 'A partir del {end} se cobran {amount} al mes por lo que tienes contratado, al inicio de cada mes de facturación.',
        chargeNoTotal: 'A partir del {end} tu contratación se cobra mensualmente, al inicio de cada mes de facturación.',
        firstCharge: 'El primer cobro es el {date}.',
        demoCounted: 'El tiempo que pasaste en la demo contó para tu periodo de prueba.',
        over: 'Tu periodo de prueba ha terminado y tu contratación se factura mensualmente.',
        monthly: 'Son {amount} al mes.',
        nextCharge: 'El próximo cobro es el {date}.',
      },
      continue: 'Continuar con la configuración',
    },
    avv: {
      modalTitle: 'Acepta el acuerdo de tratamiento de datos (AVV)',
      modalBody:
        'Configurar tu suite con datos reales significa que lumi trata datos personales en tu nombre. Antes de continuar, lee y acepta nuestro acuerdo de tratamiento de datos (AVV) actual.',
      modalLinkText: 'Leer el AVV completo',
      modalCheckboxLabel: 'He leído y acepto el AVV actual.',
      modalCancel: 'Todavía no',
      modalAccept: 'Aceptar y continuar',
    },
    preparing: {
      first: {
        title: 'Tu demo se está preparando.',
        body: 'Estamos creando una empresa ficticia y coherente en todos tus módulos. Solo tardará un momento.',
      },
      reset: {
        title: 'Tu demo se está restableciendo.',
        body: 'Estamos vaciando la empresa de demostración y creándola de nuevo desde cero. Tu espacio de trabajo y tus compañeros no se tocan. Solo tardará un momento.',
      },
      stuck: {
        note: 'Esto está tardando más de lo esperado.',
        cta: 'Configurar manualmente',
      },
    },
    nonAdmin: {
      title: 'Casi',
      titleMark: 'listo.',
      body: 'Tu administrador o administradora todavía está configurando la suite. En cuanto termine, entrarás directamente aquí.',
    },
    wizard: {
      title: 'Configura tu suite',
      subtitle: 'Aquí todo es opcional y tu progreso se guarda. Configura lo que quieras, finaliza la configuración o vuelve a la demo cerrando esta ventana.',
      subtitleCommitting: 'Se está aplicando tu configuración. Si un paso falla, puedes omitirlo y configurarlo más tarde en los ajustes.',
      crossRef: 'Se usa en {modules}: podrás cambiarlo más tarde en {owner}.',
      crossRefOwnerDefault: 'Personal',
      recovery: 'No se pudo aplicar «{step}». Revisa tus datos ahí y finaliza de nuevo.',
      details: {
        step: 'Tus datos',
        title: 'Tus datos',
        subtitle: 'Tu propio registro en Personal. Revisa tu nombre: al guardarlo, confirmas tu registro.',
        loading: 'Cargando tu registro…',
        confirmed: 'Tu registro está confirmado como {name}. Puedes cambiarlo más adelante en Personal.',
        unavailable: 'Ahora mismo no se ha podido cargar tu registro. Puedes confirmarlo más adelante en Personal.',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        required: 'Introduce tu nombre y tus apellidos.',
        hq: {
          title: 'Vuestra sede',
          why: 'Lumi no puede funcionar sin una ubicación: necesita vuestra sede como primera ubicación, por ejemplo para vuestras ofertas de empleo.',
          street: 'Calle',
          postalCode: 'Código postal',
          city: 'Ciudad',
          country: 'País',
          countryNone: 'Ningún país seleccionado',
          required: 'Introduce la calle, el código postal, la ciudad y el país de vuestra sede.',
        },
      },
      general: {
        title: 'General',
        company: {
          title: 'Perfil de la empresa',
        },
        name: {
          label: 'Nombre de la empresa',
          hint: 'Rellenado desde el pago — edítalo si hace falta. Obligatorio.',
          required: 'El nombre de la empresa es obligatorio.',
        },
        profile: {
          industry: 'Sector',
          employeeCountRange: 'Tamaño de la empresa',
          employeeCountPlaceholder: 'p. ej. 50–200',
          foundedYear: 'Fundada',
          foundedYearPlaceholder: 'p. ej. 2010',
          legalForm: 'Forma jurídica',
          websiteUrl: 'Sitio web',
        },
        place: {
          hint: 'Elige una ciudad de la lista como nombre de la ubicación, o escribe uno propio y confirma con Intro o +.',
        },
        org: {
          title: 'Estructura de la organización',
          subtitle: 'Departamentos, ubicaciones y centros de coste a los que pertenece tu personal.',
          departments: 'Departamentos',
          locations: 'Ubicaciones',
          costCenters: 'Centros de coste',
          empty: 'Ninguno todavía',
          addDepartment: 'Nuevo departamento',
          addLocation: 'Nueva ubicación, p. ej. Madrid',
          addCostCenter: 'Nuevo centro de coste',
        },
      },
      finish: {
        cta: 'Finalizar configuración',
        step: 'Fin',
        title: 'Finaliza tu configuración',
        body: 'Al finalizar se aplican tus respuestas. Podrás cambiarlo todo más tarde en cada módulo.',
        nextTitle: 'A continuación: invita a tu equipo',
        nextBody: 'Tras la configuración, abre el área de administración para invitar a los primeros usuarios y asignarles sus roles.',
        demoWarning: 'Al finalizar se elimina la empresa de demostración y cualquier usuario invitado mientras la explorabas.',
      },
      sections: {
        ats: {
          title: 'Reclutamiento',
          subtitle: 'Configura cómo funcionan las candidaturas y los correos de reclutamiento.',
          fields: {
            fromName: { label: 'Nombre del remitente', hint: 'Se muestra en los correos a candidatos.' },
            signature: { label: 'Firma de correo', hint: 'Se añade a los correos salientes a candidatos.' },
          },
          jobPosting: {
            title: 'Oferta de empleo',
            hint: 'El contacto de la candidatura y el logotipo que se muestran en las ofertas de empleo externas (opcional: también puedes configurarlo más tarde).',
            contactName: 'Nombre de contacto',
            contactEmail: 'Correo de contacto',
            logo: 'Logotipo de la oferta',
            uploadLogo: 'Subir logotipo',
            removeLogo: 'Quitar',
            rePick: 'Tu logotipo aún no se ha subido: vuelve a seleccionarlo.',
            contactEmailInvalid: 'Introduce una dirección de correo electrónico válida.',
          },
          workflow: {
            title: 'Proceso de contratación',
            participantsQuestion: '¿Quién participa en las ofertas de empleo y las candidaturas?',
            worksCouncil: 'Comité de empresa',
            sbv: 'Representación de personas con discapacidad',
            legalSignOff: 'Jurídico: aprueba una oferta de empleo antes de publicarla',
            assessmentCentreQuestion: '¿Utilizáis centros de evaluación?',
            assessmentCentre: 'Sí, utilizamos centros de evaluación',
            hint: 'Puedes editar y actualizar el proceso más adelante en el ATS, en cualquier momento.',
          },
        },
        time_tracking: {
          title: 'Tiempo',
          subtitle: 'Tipos de registro y reglas de jornada.',
          fields: {
            bookingTypes: { label: 'Tipos de registro', hint: 'Añade los tipos de registro que uses.', placeholder: 'p. ej. Trabajo' },
          },
          companyHolidays: {
            title: 'Vacaciones de empresa',
            hint: 'Días en que la empresa está cerrada; por ejemplo, medio día en Nochebuena y Nochevieja. Esos días no generan horas teóricas. En cada entrada decides si se descuenta de las vacaciones; podrás cambiarlo después en los ajustes de Tiempo.',
            empty: 'Aún no hay vacaciones de empresa.',
            suggestions: 'Sugerencias:',
            christmasEve: 'Nochebuena',
            newYearsEve: 'Nochevieja',
            name: 'Nombre',
            namePlaceholder: 'p. ej. Entre Navidad y Año Nuevo',
            from: 'Desde',
            to: 'Hasta (opcional)',
            halfDay: 'Medio día',
            yearly: 'Cada año',
            deductsFromLeave: 'Descontar de las vacaciones',
            rangeReversed: 'La fecha de fin es anterior a la de inicio.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Profesiones de formación.',
          fields: {
            professions: { label: 'Profesiones de formación', hint: 'Las profesiones de aprendizaje en las que formas.', placeholder: 'p. ej. Técnico/a informático/a' },
          },
        },
        people: {
          title: 'Personal',
          subtitle: 'Vocabulario compartido en toda la suite.',
          fields: {
            salutations: { label: 'Tratamientos', hint: 'Añade tratamientos además del conjunto estándar.', placeholder: 'p. ej. Mx' },
            contractTypes: { label: 'Tipos de contrato', hint: 'Añade tipos de contrato además del conjunto estándar.', placeholder: 'p. ej. Estudiante trabajador' },
            workTimeModels: { label: 'Modelos de jornada', hint: 'Añade modelos además del conjunto estándar.', placeholder: 'p. ej. Trabajo compartido' },
            workLocationTypes: { label: 'Lugares de trabajo', hint: 'Añade tipos de lugar de trabajo además del conjunto estándar.', placeholder: 'p. ej. Trabajo de campo' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Borrando la demostración…',
        body: 'Eliminando la empresa de demostración para que tu configuración real empiece limpia.',
      },
      applying: {
        title: 'Configurando tu suite…',
        body: 'Aplicando tus respuestas. Solo tardará un momento.',
      },
      steps: {
        company: 'Perfil de la empresa',
      },
      error: 'Algo salió mal al aplicar tu configuración.',
      retry: 'Reintentar',
      backToSetup: 'Volver a la configuración',
      skipStep: 'Finalizar sin este paso',
      skipped: 'Omitido: {steps}. Puedes configurarlo cuando quieras en los ajustes.',
      resume: 'Reanudar configuración',
      stalled: 'Esto está tardando más de lo esperado.',
      wipeFailed: 'No se pudo borrar la demostración. Reintenta para continuar.',
      logoMissing: 'Tu logotipo no se subió (se perdió al recargar): puedes añadirlo más tarde en la configuración de anuncios de empleo.',
      workflowFailed: 'No se pudo generar tu cadena de contratación, así que tu espacio de trabajo empieza con la cadena estándar. Todo lo demás se aplicó: abre los ajustes de workflow en Reclutamiento para volver a ejecutar el generador.',
      workflowDrafted: "Tu proceso de contratación se guardó como borrador porque {roles} todavía no tiene a nadie asignado. Abre los ajustes de workflow en Reclutamiento para activarlo en cuanto el rol esté cubierto.",
      workflowRoles: {
        ats_works_council: "el comité de empresa",
        ats_sbv: "la representación de las personas con discapacidad",
        ats_legal: "el departamento jurídico",
      },
      continue: 'Continuar al espacio de trabajo',
    },
  },
  tenants: {
    switcherLabel: 'Cambiar de espacio de trabajo',
    supportAccessBadge: 'Soporte',
    supportAccessUntil: 'Acceso temporal de soporte hasta {until}',
    supportAccessBanner: 'El soporte de lumi tiene actualmente acceso temporal a este espacio.',
    supportAccessReview: 'Revisar',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Qué bloquea un borrado',
      intro: 'Los documentos del expediente sin plazo de conservación se guardan indefinidamente: nadie ha decidido cuánto tiempo deben conservarse, y un documento sin decidir nunca se borra automáticamente. Aquí los tienes para poder fijar los plazos.',
      sensitivePlaceholder: 'Documento sensible',
      categories: {
        contract: 'Contrato',
        contract_amendment: 'Modificación del contrato',
        certificate: 'Certificado',
        attestation: 'Justificante',
        warning: 'Amonestación',
        other: 'Otro documento',
      },
      outcomes: {
        refused: 'Borrado denegado',
        partial: 'Borrado parcialmente',
      },
      list: {
        title: 'Documentos sin plazo de conservación',
        fixHint: 'Primero los más antiguos. Fija un plazo de conservación en el documento del expediente y desaparecerá de esta lista.',
        loading: 'Cargando documentos…',
        loadError: 'No se ha podido cargar la lista. Inténtalo de nuevo: esto no significa «no hay nada».',
        empty: 'Todos los documentos de este espacio de trabajo tienen un plazo de conservación.',
        uploadedLabel: 'Subido',
        truncated: 'Solo se muestran los {count} documentos más antiguos. Hay más esperando un plazo de conservación.',
      },
    },
    myData: {
      title: 'Mis datos',
      intro: 'Aquí puedes preguntar qué datos guarda este espacio de trabajo sobre ti, pedir que se corrijan o solicitar que se supriman. Cada solicitud queda registrada y la responden las personas encargadas de la protección de datos en este espacio, y puedes seguirla aquí.',
      requests: {
        title: 'Mis solicitudes',
        loading: 'Cargando tus solicitudes…',
        loadError: 'No se han podido cargar tus solicitudes. Aun así puedes enviar una solicitud más abajo.',
        empty: 'Todavía no has enviado ninguna solicitud.',
        filedLabel: 'Enviada',
        dueLabel: 'Respuesta prevista',
        outcomeLabel: 'Resultado',
        awaitingRelease: 'Copia en revisión',
      },
      kinds: {
        access: 'Copia de mis datos',
        rectification: 'Rectificación',
        erasure: 'Supresión',
      },
      statuses: {
        received: 'Recibida',
        verifying: 'Comprobando tu identidad',
        in_progress: 'En tramitación',
        awaiting_subject: 'Esperando tu respuesta',
        completed: 'Finalizada',
        refused: 'Denegada',
        withdrawn: 'Retirada',
      },
      outcomes: {
        erased: 'Datos suprimidos',
        suppressed: 'Datos suprimidos, se conserva un registro mínimo',
        refused: 'Denegada',
        partial: 'Parcialmente resuelta',
        answered: 'Respondida',
      },
      actions: {
        access: {
          title: 'Pedir una copia de mis datos',
          body: 'Puedes pedir una copia de los datos que este espacio de trabajo guarda sobre ti. No es una descarga inmediata: primero se prepara la copia y se te avisa cuando está lista.',
          where: 'Una copia lista nunca se envía como archivo adjunto. Recibes un correo, inicias sesión en tu cuenta de lumi HR y la descargas allí.',
          cta: 'Pedir una copia',
          detailLabel: 'Añadir algo (opcional)',
          detailHint: 'Por ejemplo, si solo quieres una parte de tus datos.',
        },
        rectification: {
          title: 'Pedir una rectificación',
          body: 'Si algo que este espacio de trabajo guarda sobre ti es incorrecto o está desactualizado, puedes pedir que se rectifique.',
          cta: 'Pedir una rectificación',
          detailLabel: '¿Qué es incorrecto y qué debería decir?',
          detailHint: 'Describe los datos con la mayor precisión posible para que puedan localizarse y comprobarse.',
          selfTitle: 'Algunas cosas puedes cambiarlas tú',
          selfFields: 'Tu nombre y tratamiento, tu género, tu correo de contacto, tu teléfono, tu dirección, tu nacionalidad, tu estado civil y tu idioma los editas en tu perfil.',
          selfLink: 'Abrir mi perfil',
          askBody: 'Para todo lo demás —fecha de nacimiento, número de empleado, datos de contrato, nómina o impuestos, tus documentos— usa la solicitud de abajo.',
        },
        erasure: {
          title: 'Pedir la supresión de mis datos',
          body: 'Puedes pedir a este espacio de trabajo que suprima los datos que guarda sobre ti.',
          cta: 'Pedir la supresión',
          confirm: 'Tu solicitud la revisan las personas responsables de este espacio de trabajo. Los datos que deben conservarse por ley, o que siguen siendo necesarios para tu relación laboral, no pueden suprimirse. Se te dirá qué se ha suprimido y qué se conserva.',
          detailLabel: 'Añadir algo (opcional)',
          detailHint: 'Por ejemplo, a qué datos te refieres si no son todos.',
        },
      },
      form: {
        submit: 'Enviar solicitud',
        submitting: 'Enviando…',
        cancel: 'Cancelar',
        success: 'Tu solicitud queda registrada. La encuentras arriba, en «Mis solicitudes».',
        errorGeneric: 'No se ha podido enviar tu solicitud. No se ha registrado nada; inténtalo de nuevo.',
        errorRateLimit: 'Has enviado varias solicitudes en poco tiempo. Inténtalo más tarde.',
      },
    },
    export: {
      title: 'Exportar este espacio de trabajo',
      intro: 'Puedes descargar en cualquier momento una copia completa de todo lo que guarda este espacio de trabajo, en un formato legible por máquina y sin pedírnoslo.',
      contents: {
        title: 'Qué contiene este archivo',
        body: 'El archivo contiene los datos de todas las personas en claro y, junto a ellos, las claves de acceso activas de este espacio de trabajo: la clave de IA, los enlaces de calendario con sus tokens y las credenciales de los proveedores conectados. El archivo incluye también, para Personal, Reclutamiento y Tiempo, un documento HR Open Standards (HR-JSON): el formato común para llevarte los datos a otro proveedor.',
        handling: 'Guárdalo con el mismo cuidado que esas claves. Quien consiga el archivo y la contraseña lo tiene todo.',
      },
      roleRequired: {
        title: 'Esta exportación necesita el rol «Protección de datos»',
        body: 'El archivo contiene todos los ficheros guardados en este espacio de trabajo —nóminas, certificados médicos y documentos de identidad incluidos— junto a los datos personales de todas las personas y las claves de acceso activas de este espacio de trabajo.',
        hint: 'Ser propietario del espacio de trabajo ya no basta: quien inicie la exportación también debe tener el rol «Protección de datos». Ese rol se asigna junto con los demás roles de la suite en la administración de usuarios, y también se te puede asignar a ti.',
      },
      start: {
        title: 'Iniciar una exportación',
        body: 'Elige una contraseña. El archivo se cifra con ella y solo con ella se puede abrir.',
        passphraseWarning: 'Nunca guardamos tu contraseña ni podemos recuperarla. Si la pierdes, el archivo ya no se puede abrir: no hay forma de restablecerla.',
        passphraseLabel: 'Contraseña',
        passphraseHint: 'Al menos {min} caracteres. Elige algo largo que puedas guardar de forma segura.',
        confirmLabel: 'Repite la contraseña',
        submit: 'Iniciar exportación',
        submitting: 'Iniciando…',
        success: 'La exportación se ha iniciado. Se prepara en segundo plano y aparecerá abajo cuando esté lista.',
        errorTooShort: 'La contraseña necesita al menos {min} caracteres.',
        errorMismatch: 'Las dos contraseñas no coinciden.',
        errorAlreadyRunning: 'Ya hay una exportación de este espacio de trabajo en curso. Espera a que termine antes de iniciar otra.',
        errorTooMany: 'Este espacio de trabajo ha iniciado por ahora el número máximo de exportaciones. Inténtalo de nuevo más tarde.',
        errorGeneric: 'No hemos podido confirmar que la exportación se haya iniciado. Consulta la lista de abajo antes de iniciar otra.',
      },
      list: {
        title: 'Exportaciones de este espacio de trabajo',
        loading: 'Cargando exportaciones…',
        loadError: 'No se pudieron cargar las exportaciones.',
        empty: 'Este espacio de trabajo aún no se ha exportado.',
        linkHint: 'Un enlace de descarga solo es válido durante un instante. Si deja de funcionar, vuelve a usar el botón.',
        retentionHint: 'Cada archivo se elimina automáticamente cuando caduca: la fecha aparece junto a él.',
        startedLabel: 'Iniciada',
        expiresLabel: 'Disponible hasta',
        download: 'Descargar',
        preparing: 'Preparando…',
        downloadError: 'No se pudo preparar la descarga. Puede que el archivo ya no esté.',
        gone: 'El archivo se ha eliminado. Inicia una nueva exportación si necesitas otra copia.',
        failedHint: 'Esta exportación no llegó a terminar. Puedes iniciar otra.',
        runningHint: 'Esta exportación aún se está preparando.',
      },
      statuses: {
        requested: 'Solicitada',
        exporting: 'Preparándose',
        exported: 'Lista',
        failed: 'Fallida',
        expired: 'Eliminada',
      },
    },
    settingsPanel: {
      title: 'Tratamiento de datos',
      body: 'Puedes pedir que se borren o corrijan tus datos, o solicitar una copia, {link}.',
      linkLabel: 'aquí',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Esta lista es para el rol de protección de datos',
      description: 'Las solicitudes de las personas interesadas las tramita el propietario del espacio de trabajo o quien tenga el rol «Protección de datos».',
    },
    intro: {
      title: 'Solicitudes de personas interesadas',
      body: 'Solicitudes de personas sobre los datos que este espacio de trabajo guarda de ellas. Cada una debe responderse en el plazo de un mes desde su recepción (art. 12.3 del RGPD). Si la solicitud es compleja, el plazo puede prorrogarse dos veces un mes, con un motivo que hay que comunicar a la persona.',
    },
    filters: {
      label: 'Mostrar solicitudes',
      open: 'Abiertas',
      overdue: 'Fuera de plazo',
      dueSoon: 'Vencen en 7 días',
      closed: 'Respondidas recientemente',
    },
    empty: {
      title: 'No hay solicitudes de personas interesadas',
      description: 'Cuando alguien pregunte por sus datos —en lumi o por correo electrónico, postal o teléfono—, la solicitud aparecerá aquí con su plazo.',
    },
    emptyFilter: 'No hay solicitudes en esta vista.',
    truncated: 'No caben todas las solicitudes en esta página. Los plazos más próximos aparecen primero.',
    badges: {
      overdue: 'Fuera de plazo',
      dueSoon: 'Vence pronto',
      legalHold: 'Retención legal',
      reviewReady: 'Listo para revisar',
      reviewReleased: 'Liberada',
      reviewDelivered: 'Entregada',
    },
    row: {
      received: 'Recibida',
      due: 'Respuesta antes del',
      closed: 'Cerrada',
      subject: 'Se refiere a',
      channel: 'Llegó por',
      outcome: 'Resultado',
      extensions: 'Plazo prorrogado {count} de 2 veces',
      postponed: 'Recordatorios en pausa hasta el {date}',
      vetoWindow: 'La supresión aún puede detenerse hasta el {date}',
      reviewFlagged: 'Hace falta tu decisión: {flagged} de {total} entradas',
      reviewNoneFlagged: 'Ninguna entrada marcada',
      reviewEmpty: 'La copia no contiene entradas',
      reviewOpen: 'Revisar',
      reviewReleased: 'Liberada, en proceso de entrega',
      reviewDelivered: 'Entregada, cerrándose',
    },
    legalHold: {
      tenant: 'Hay una retención legal para todo el espacio de trabajo ({reason}).',
      subject: 'Hay una retención legal sobre esta persona ({reason}).',
      consequence: 'Los datos no pueden suprimirse. La respuesta lícita es una negativa que nombre esa base; la retención no detiene el plazo.',
    },
    automated: {
      pending: 'lumi responde por sí mismo a esta solicitud: cuando hayas comprobado la identidad de la persona y la pases a «En tramitación», lumi prepara la copia de sus datos. Después espera tu revisión. Cuando la liberes, se le indica a la persona dónde descargarla y la solicitud se cierra sola.',
      running: 'lumi está preparando la copia de los datos de esta persona. Después espera tu revisión: la persona solo sabrá dónde descargarla cuando la liberes.',
    },
    detail: {
      show: 'Ver quién la presentó',
      hide: 'Ocultar detalles',
      loading: 'Cargando detalles…',
      loadError: 'No se pudieron cargar los detalles de esta solicitud.',
      subjectLabel: 'Nombre indicado',
      subjectEmail: 'Correo electrónico',
      subjectPhone: 'Teléfono',
      requestDetail: 'Qué se pidió',
      onBehalfReason: 'Registrada en su nombre porque',
      extensionReason: 'Motivo de la prórroga',
      outcomeBasis: 'Base indicada',
      nothingOnFile: 'Contacto',
      nothingOnFileValue: 'No consta ningún nombre, dirección ni mensaje para esta solicitud.',
    },
    kinds: {
      access: 'Copia de sus datos',
      rectification: 'Rectificación',
      erasure: 'Supresión',
      restriction: 'Limitación del tratamiento',
      portability: 'Portabilidad de los datos',
      objection: 'Oposición al tratamiento',
    },
    statuses: {
      received: 'Recibida',
      verifying: 'Comprobando la identidad',
      in_progress: 'En tramitación',
      awaiting_subject: 'Esperando a la persona',
      completed: 'Completada',
      refused: 'Denegada',
      withdrawn: 'Retirada',
    },
    outcomes: {
      erased: 'Datos suprimidos',
      suppressed: 'Datos suprimidos, registro mínimo conservado',
      refused: 'Denegada',
      partial: 'Atendida en parte',
      answered: 'Respondida por completo',
    },
    subjectTypes: {
      person: 'Un expediente de empleado',
      tenant_user: 'Un miembro sin expediente de empleado',
      candidate: 'Un candidato',
      unlinked: 'Sin vincular a ningún registro',
    },
    channels: {
      'self-service': 'Presentada en lumi por la persona',
      'candidate-portal': 'Portal de candidatos',
      email: 'Correo electrónico',
      post: 'Correo postal',
      phone: 'Teléfono',
      unknown: 'No registrado',
    },
    actions: {
      advance: {
        verifying: 'Comprobar la identidad',
        in_progress: 'Empezar a tramitarla',
        awaiting_subject: 'Esperar a la persona',
      },
      extend: 'Prorrogar el plazo',
      close: 'Cerrar la solicitud',
      postpone: 'Pausar recordatorios',
      veto: 'Abrir plazo de veto',
      hold: 'Retener a esta persona',
      restrict: 'Limitar el tratamiento',
      record: 'Registrar una solicitud',
    },
    confirmAutomated: {
      title: '¿Preparar la copia de los datos de esta persona?',
      body: 'Al pasar la solicitud a «En tramitación», lumi reunirá todo lo que este espacio de trabajo guarda sobre la persona. La copia todavía no le llega: espera tu revisión, y la persona solo sabrá dónde descargarla cuando la liberes. Hazlo solo cuando su identidad esté acreditada.',
      confirm: 'Empezar',
    },
    toast: {
      advanced: 'Solicitud pasada a «{status}».',
      extended: 'Plazo prorrogado hasta el {date}.',
      closed: 'Solicitud cerrada.',
      postponed: 'Recordatorios pausados hasta el {date}.',
      vetoOpened: 'Plazo de veto abierto. La supresión espera 72 horas.',
      holdPlaced: 'Retención legal establecida.',
      holdReleased: 'Retención legal levantada.',
      holdAttested: 'Retención legal confirmada por seis meses más.',
      restrictionPlaced: 'Tratamiento limitado.',
      restrictionNotified: 'Comunicación registrada.',
      restrictionLifted: 'Limitación levantada.',
      recorded: 'Solicitud registrada.',
    },
    extend: {
      title: 'Prorrogar el plazo',
      body: 'El art. 12.3 del RGPD permite dos prórrogas de un mes cuando la solicitud es compleja o hay muchas. Infórmalo a la persona durante el primer mes, con el motivo.',
      remaining: 'Prórrogas restantes: {count}',
      reasonLabel: 'Motivo del retraso',
      reasonHint: 'Se guarda con la solicitud. Da a la persona el mismo motivo.',
      submit: 'Prorrogar un mes',
      errorReason: 'Indica el motivo del retraso.',
    },
    close: {
      title: 'Cerrar la solicitud',
      body: 'Una solicitud cerrada no puede reabrirse: es el registro de cómo y cuándo respondió el espacio de trabajo.',
      statusLabel: '¿Cómo se cerró?',
      outcomeLabel: 'Qué se hizo',
      outcomePlaceholder: 'Elegir…',
      basisLabel: 'Base jurídica',
      basisHint: 'El fundamento de lo que se conservó o denegó, por ejemplo una obligación de conservación o el art. 12.5 del RGPD.',
      submit: 'Cerrar la solicitud',
      errorOutcome: 'Elige qué se hizo.',
      errorBasis: 'Una negativa o una respuesta parcial debe nombrar su base jurídica.',
      conflict: 'La solicitud no se pudo cerrar así. Una retención legal o una ventana de veto abierta puede impedir suprimir los datos, o la solicitud ha cambiado entretanto: recarga la lista y compruébalo.',
    },
    record: {
      title: 'Registrar una solicitud',
      body: 'Para una solicitud que llegó por correo electrónico, correo postal o teléfono. El plazo de un mes corre desde el día en que llegó, no desde hoy. Una solicitud registrada empieza como recibida.',
      choose: 'Elegir…',
      kindLabel: 'Tipo de solicitud',
      channelLabel: 'Llegó por',
      receivedLabel: 'Recibida el',
      receivedHint: 'El día en que la solicitud llegó al espacio de trabajo; como muy tarde, hoy.',
      subjectLabel: 'Persona afectada',
      modes: {
        person: 'Una persona en Personal',
        candidate: 'Una candidatura en Reclutamiento',
        unlinked: 'Sin registro',
      },
      personLabel: 'Buscar a la persona',
      personHint: 'Busca por nombre o dirección de correo electrónico.',
      candidateLabel: 'Candidato o candidata',
      candidateHint: 'Busca por nombre o correo electrónico. Solo aparecen las candidaturas que tu rol en Reclutamiento puede abrir.',
      candidateRefused: 'Tus roles en Reclutamiento no permiten buscar candidaturas. Elige «Sin registro» e indica el nombre que dio la persona.',
      searchPlaceholder: 'Nombre o correo electrónico',
      picker: {
        searching: 'Buscando…',
        typeMore: 'Al menos {count} caracteres',
        noMatch: 'Sin resultados. Si la persona no consta en ningún sitio, elige «Sin registro».',
        error: 'La búsqueda falló. Si la persona no consta en ningún sitio, elige «Sin registro».',
        refused: 'Tus roles no permiten buscar candidaturas.',
        rateLimited: 'Demasiadas búsquedas – enseguida seguimos',
        resultsAnnouncement: 'Un resultado | {count} resultados',
        clear: 'Quitar selección',
      },
      nameLabel: 'Nombre indicado',
      nameHint: 'Tal como la persona firmó o se presentó.',
      emailLabel: 'Correo electrónico (opcional)',
      detailLabel: '¿Qué se pide?',
      detailHint: 'Opcional. En lo posible, con las palabras de la persona.',
      reasonLabel: '¿Por qué la registras en su nombre?',
      reasonHint: 'Por ejemplo: carta a RR. HH. del 3 de mayo, o llamada atendida en recepción. Se guarda con tu nombre.',
      submit: 'Registrar solicitud',
      errorKind: 'Elige el tipo de solicitud.',
      errorChannel: 'Elige cómo llegó la solicitud.',
      errorReceived: 'Elige el día en que llegó la solicitud.',
      errorFuture: 'Una solicitud no puede llegar en el futuro. Elige hoy o un día anterior.',
      errorPerson: 'Elige a la persona en la búsqueda, o «Sin registro».',
      errorCandidate: 'Elige la candidatura en la búsqueda, o «Sin registro».',
      errorName: 'Indica el nombre que dio la persona.',
      errorEmail: 'Introduce un correo electrónico válido o deja el campo vacío.',
      errorReason: 'Indica por qué registras la solicitud en su nombre.',
    },
    errors: {
      conflict: 'Este paso ya no es posible: la solicitud ha cambiado entretanto. Recarga la lista.',
      notLinked: 'Esta solicitud no está vinculada a ningún registro, así que no hay nadie a quien retener o limitar.',
    },
    progress: {
      title: 'Supresión por módulo',
      show: 'Mostrar el avance de la supresión',
      hide: 'Ocultar el avance de la supresión',
      loading: 'Cargando el registro de supresión…',
      loadError: 'No se pudo cargar el registro de supresión.',
      unlinked: 'Esta solicitud no está vinculada a ningún registro, así que ningún módulo suprimió nada por ella.',
      lastExecuted: 'registrado el {date}',
      states: {
        done: 'Suprimido',
        heldNothing: 'No guardaba nada',
        pending: 'Aún sin registrar',
        deferred: 'Aplazado: módulo desactivado',
      },
      modules: {
        people: 'Personal',
        ats: 'Candidaturas',
        time: 'Tiempo',
        apprentice: 'Formación',
        payroll: 'Nómina',
        privacy: 'Registro de protección de datos',
      },
    },
    postpone: {
      title: 'Pausar los recordatorios',
      body: 'Detiene los correos de recordatorio hasta el día elegido. El plazo legal no se mueve; para moverlo, prorroga la solicitud.',
      untilLabel: 'Pausar hasta',
      untilHint: 'Como muy tarde la fecha límite de respuesta, el {date}.',
      reasonLabel: 'Motivo',
      reasonHint: 'Se guarda con la solicitud para poder justificar la pausa más adelante.',
      submit: 'Pausar recordatorios',
      errorUntil: 'Elige el día en que se reanudan los recordatorios.',
      errorRange: 'Elige un día entre mañana y la fecha límite de respuesta.',
      errorReason: 'Indica el motivo de la pausa.',
    },
    veto: {
      title: '¿Abrir el plazo de veto?',
      body: 'Durante las próximas 72 horas se retiene la supresión: la solicitud no puede cerrarse como suprimida. Aprovecha para comprobar si hace falta una retención legal o una denegación. El plazo no se puede cerrar antes.',
      confirm: 'Abrir plazo de veto',
    },
    holds: {
      title: 'Retenciones legales',
      intro: 'Una retención legal impide que se supriman datos —por una solicitud, las reglas de conservación o la eliminación del espacio de trabajo— hasta que se levante. Cada retención debe confirmarse de nuevo cada seis meses.',
      placeTenant: 'Retener todo el espacio de trabajo',
      empty: 'No hay ninguna retención legal activa.',
      lapsedNotice: 'Retenciones con la fecha de confirmación vencida: {count}. Siguen bloqueando la supresión; confírmalas o levántalas.',
      scopeTenant: 'Todo el espacio de trabajo',
      scopeSubject: 'Una persona',
      lapsed: 'Confirmación vencida',
      placedAt: 'Establecida el',
      attestationDue: 'Confirmar antes del',
      basis: 'Base jurídica',
      attest: 'Sigue siendo necesaria',
      attestConfirm: {
        title: '¿Mantener esta retención?',
        body: 'Confirmas que el motivo de la retención sigue vigente. Se mantiene seis meses más.',
        confirm: 'Mantener retención',
      },
      release: {
        open: 'Levantar',
        title: 'Levantar la retención legal',
        warning: 'A partir de ahora, los datos que protegía esta retención pueden suprimirse: por solicitudes pendientes, las reglas de conservación o la eliminación del espacio de trabajo. No se puede deshacer.',
        reasonLabel: '¿Por qué ya no hace falta la retención?',
        reasonHint: 'Se guarda con tu nombre.',
        submit: 'Levantar retención',
        errorReason: 'Indica el motivo del levantamiento.',
      },
      place: {
        titleTenant: 'Retener todo el espacio de trabajo',
        titleSubject: 'Retener a esta persona',
        bodyTenant: 'Mientras exista la retención, no se puede suprimir ningún dato de este espacio de trabajo: ni por solicitudes, ni por las reglas de conservación, ni por la eliminación del espacio de trabajo.',
        bodySubject: 'Mientras exista la retención, no se puede suprimir ningún dato de la persona que nombra esta solicitud. La solicitud debe contestarse igualmente dentro del plazo.',
        reasonLabel: 'Motivo',
        reasonHint: 'Por ejemplo, el procedimiento judicial o el requerimiento de una autoridad que obliga a conservar los datos.',
        basisLabel: 'Base jurídica (opcional)',
        basisHint: 'Una referencia breve, por ejemplo la norma o el número de expediente.',
        submit: 'Establecer retención',
        errorReason: 'Indica el motivo de la retención.',
      },
      errors: {
        notActive: 'Esta retención ya no está activa: se modificó entretanto. La lista se ha vuelto a cargar.',
      },
    },
    restrictions: {
      title: 'Limitaciones del tratamiento',
      intro: 'Un registro limitado puede conservarse, pero no utilizarse (art. 18 RGPD). Antes de levantar una limitación hay que informar a la persona.',
      empty: 'No hay ningún tratamiento limitado.',
      originSystem: 'Establecida tras una supresión',
      originRequest: 'De una solicitud',
      notified: 'Persona informada el {date}',
      notNotified: 'Persona aún no informada',
      placedAt: 'Limitado desde el {date}',
      notifyOpen: 'Informar a la persona',
      notifyAgain: 'Registrar nueva comunicación',
      lift: 'Levantar limitación',
      liftConfirm: {
        title: '¿Levantar la limitación?',
        body: 'El registro puede volver a utilizarse como antes. La persona ha sido informada.',
        bodySystem: 'Esta limitación se estableció automáticamente sobre lo que se conservó tras suprimir los datos de la persona. Al levantarla, esos registros vuelven a poder editarse y utilizarse. Levántala solo si la limitación ya no es necesaria.',
        confirm: 'Levantar limitación',
      },
      errors: {
        notActive: 'Esta limitación ya no está activa o la persona aún no ha sido informada. La lista se ha vuelto a cargar.',
      },
      place: {
        title: 'Limitar el tratamiento',
        body: 'El registro de la persona que nombra esta solicitud se conserva, pero ya no puede utilizarse hasta que se levante la limitación. La limitación queda vinculada a esta solicitud.',
        reasonLabel: 'Motivo',
        reasonHint: 'Por ejemplo: la persona impugna la exactitud de los datos.',
        submit: 'Limitar',
        errorReason: 'Indica el motivo de la limitación.',
      },
      notify: {
        title: 'Informar a la persona',
        body: 'Hay que informar a la persona antes de levantar la limitación (art. 18, apdo. 3, RGPD).',
        modeLabel: '¿Cómo se informa a la persona?',
        modeSend: 'lumi envía un correo',
        modeManual: 'Ya informada de otra forma',
        manualOnly: 'Esta limitación no está vinculada a ninguna solicitud, así que lumi no tiene dirección. Informa tú a la persona y regístralo aquí.',
        employerLabel: 'Empleador indicado en el correo',
        employerHint: 'La persona debe poder ver quién limitó sus datos.',
        refLabel: 'Referencia',
        refHint: 'Cómo la informaste, por ejemplo «carta del 3 de mayo» o un número de expediente.',
        dateLabel: 'Informada el',
        dateHint: 'Déjalo vacío para hoy.',
        submitSend: 'Enviar correo',
        submitManual: 'Registrar comunicación',
        sendRefused: 'No se pudo enviar el correo: la solicitud no contiene ninguna dirección de correo. Informa a la persona de otra forma y regístralo.',
        errorEmployer: 'Indica el empleador.',
        errorRef: 'Indica una referencia de la comunicación.',
      },
    },
    review: {
      title: 'Revisar la copia',
      intro: 'Así leerá la persona su copia. Tú decides cada entrada marcada por separado: liberarla o retenerla (art. 15, apdo. 4, RGPD). Todo lo demás es solo de lectura.',
      back: 'Volver a las solicitudes',
      counter: {
        undecided: 'Faltan por decidir {undecided} de {flagged} entradas',
        allDecided: 'Las {flagged} entradas marcadas están decididas',
        noneFlagged: 'Ninguna entrada está marcada: puedes liberar la copia directamente',
      },
      modules: {
        people: 'Personal',
        ats: 'Candidaturas',
        time: 'Tiempo',
        apprentice: 'Formación',
      },
      moduleState: {
        notInstalled: 'Este módulo no forma parte de este espacio de trabajo, así que no hay nada guardado en él.',
        removed: 'Este módulo se eliminó del espacio de trabajo; no queda nada sobre la persona.',
        unavailable: 'No se pudo acceder a este módulo al preparar la copia: esta área falta en la copia. Pon la solicitud en «Esperar a la persona» y después otra vez en «Empezar a tramitarla»; lumi preparará la copia de nuevo. O libérala a sabiendas sin esta área.',
      },
      moduleEmpty: 'Aquí no hay nada guardado sobre la persona.',
      delivered: 'Entregada: lumi cierra la solicitud en un momento',
      self: {
        title: 'Esta solicitud te afecta a ti',
        description: 'Otra persona responsable de protección de datos debe revisar la copia. Puedes responder a la solicitud a mano.',
      },
      unverified: 'lumi no pudo comprobar ahora si esta solicitud te afecta a ti. Inténtalo de nuevo en un momento.',
      sectionMeta: 'Tratamiento: {activity}',
      flagged: 'Marcada',
      flagReason: {
        written: 'Escrita por otra persona sobre la persona afectada, o nombra a otras personas. Valora si la persona puede leer esta entrada.',
        generic: 'Puede contener información sobre otras personas o proceder de otras personas. Valórala según el art. 15, apdo. 4, RGPD.',
      },
      state: {
        undecided: 'Aún sin decidir',
        release: 'Se liberará',
        withhold: 'Se retendrá',
      },
      decision: {
        group: 'Decisión sobre una entrada de «{section}»',
        release: 'Liberar',
        withhold: 'Retener',
        changeReason: 'Cambiar el motivo',
        reasonLabel: 'Motivo para la persona',
        reasonHint: 'La persona leerá este motivo en su copia. Escríbelo pensando en ella y no repitas el contenido de la entrada.',
        reasonSave: 'Guardar como retenida',
        reasonRequired: 'Indica un motivo.',
        saveError: 'No se pudo guardar la decisión. La entrada conserva su estado anterior.',
      },
      release: {
        action: 'Liberar la copia',
        blocked: 'Decide primero las {undecided} entradas marcadas pendientes; después podrás liberar la copia.',
        confirmTitle: '¿Liberar la copia?',
        confirmBody: 'lumi crea ahora la copia sin las entradas retenidas ({withheld}), avisa a la persona y cierra la solicitud.',
        confirmBodyNone: 'lumi crea ahora la copia, avisa a la persona y cierra la solicitud.',
        confirmLabel: 'Liberar',
        done: 'Liberada: lumi entrega la copia',
      },
      errors: {
        undecided: 'Aún quedan entradas marcadas sin decidir. Se ha recargado la página.',
        expired: 'La copia ha caducado: lumi crea una nueva y la verás aquí de nuevo en breve',
        closed: 'La solicitud ya no está abierta. La copia ya no se puede liberar.',
      },
      notFound: {
        title: 'Aquí no hay ninguna copia esperando',
        description: 'La copia ha caducado o ya se entregó. Si la solicitud sigue abierta, lumi crea una nueva y la verás de nuevo en la lista en breve.',
      },
    },
  },
  legalNotices: {
    title: 'Aviso de privacidad e IA para empleados',
    intro: 'Lo que este espacio de trabajo comunica a sus propios empleados sobre privacidad y el uso de IA en el trabajo.',
    titleLabel: 'Título',
    contentLabel: 'Texto del aviso',
    editMode: 'Editar',
    previewMode: 'Vista previa',
    followingVersion: 'Sigue la versión de lumi {version}',
    branchedFromVersion: 'Texto propio (derivado de la versión {version} el {date})',
    updateAvailable: 'Hay disponible una nueva versión de lumi ({version}).',
    compareVersions: 'Comparar',
    hideComparison: 'Ocultar comparación',
    yourText: 'Tu texto',
    lumiVersionHeading: 'Versión de lumi {version}',
    adoptVersion: 'Adoptar versión {version}',
    adoptConfirm: '¿Reemplazar tu texto en ambos idiomas por la versión {version} de lumi?',
    adopted: 'Versión de lumi adoptada.',
    saved: 'Guardado.',
    noticeRequired: 'El aviso no puede guardarse vacío.',
    lumiVersionUnavailable: 'No se pudo consultar la versión actual de lumi — inténtalo de nuevo en breve.',
    forbidden: 'No tienes acceso a este aviso.',
    supportRefused: 'Una sesión de soporte no da acceso a este aviso.',
    membershipUnavailable: 'Tu acceso no se pudo comprobar ahora mismo — inténtalo de nuevo en breve.',
    loadFailed: 'No se pudo cargar el aviso.',
    compareUnavailable: 'No se pudo contactar con lumi, así que la comparación y Adoptar no están disponibles ahora mismo.',
    blanksOpenRefusal: 'El texto todavía tiene huecos por completar: {list}. Complétalos arriba, o sustitúyelos por tu propio texto, antes de guardar.',
    unsavedWarning: 'Aún no has guardado los cambios en {name}.',
    demoDisclaimer: 'ESTA ES LA VERSIÓN DE DEMOSTRACIÓN DE UNA EMPRESA DE DEMOSTRACIÓN FICTICIA. NO ES UN DOCUMENTO LEGALMENTE VINCULANTE.',
    blanks: {
      lead: 'Las plantillas de lumi necesitan estos datos tuyos. Introduce cada uno una sola vez: se incluye en todos los textos de abajo, en los dos idiomas.',
      saved: 'Guardado.',
      complete: 'Se han indicado todos los datos necesarios.',
      suggested: 'Tomada del perfil de tu empresa: compruébala y guarda.',
      keys: {
        company_name: { label: 'Nombre de la empresa', hint: 'El nombre legal de este workspace, tal como debe aparecer en el aviso.' },
        company_address: { label: 'Dirección de la empresa', hint: 'La dirección postal donde empleados y candidatos pueden contactarte.' },
        privacy_contact: { label: 'Contacto de protección de datos', hint: 'A quién preguntar sobre protección de datos — un nombre, un cargo o un correo electrónico.' },
        applicant_retention: { label: 'Plazo de conservación de datos de candidatos', hint: 'Cuánto tiempo se conservan las candidaturas no seleccionadas antes de eliminarlas.' },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Para que tus textos legales estén completos',
      progress: '{done} de {total} hecho(s)',
      facts: { title: 'Datos para todos los textos', hint: 'Nombre de la empresa, dirección, contacto de protección de datos y más: se insertan en cada texto de abajo.' },
      imprintAction: 'Introducir el aviso legal',
    },
    candidate: {
      heading: 'Avisos para candidatos',
      intro: 'Los avisos legales que este espacio de trabajo muestra a las personas candidatas en el portal de empleo.',
      unavailable: 'Los avisos para candidatos no están disponibles ahora mismo.',
      noticeRequired: 'Este aviso se muestra a las personas candidatas y no puede quedar vacío. Sustituye el texto o adopta la versión de lumi.',
      imprintRequired: 'El aviso legal no se puede vaciar mientras el portal esté en línea. Sustituye el texto en lugar de borrarlo.',
      privacy: {
        title: 'Aviso de privacidad del inquilino',
        subtitle: 'Esta versión se muestra en el portal para candidatos.',
      },
      aiUsage: {
        title: 'Aviso sobre el uso de IA para candidatos',
        subtitle: 'Este texto se muestra a los candidatos en el portal de empleo.',
      },
      imprint: {
        title: 'Aviso legal del portal de empleo',
        subtitle: 'Este texto se enlaza desde todas las páginas del portal.',
        hint: 'El aviso legal es obligatorio por ley (§ 5 DDG). Tu portal de empleo permanece fuera de línea hasta que se guarde uno, en el idioma que sea.',
        fallsBack: 'Tu aviso legal está guardado. Los idiomas sin aviso legal propio muestran la versión {language} en el portal.',
      },
      history: {
        title: '¿Qué mostramos en una fecha concreta?',
        hint: 'Consulta el texto exacto que tenía esta página en un momento del pasado, para la pregunta de una persona candidata o de una autoridad.',
        open: 'Consultar',
        hide: 'Cerrar',
        dateLabel: 'Fecha y hora',
        localeLabel: 'Idioma',
        lookUp: 'Mostrar el texto',
        periodClosed: 'Publicado del {from} al {until}.',
        periodOpen: 'Publicado desde el {from}: sigue siendo el texto actual.',
        sourceLumi: 'La versión {version} publicada por lumi, palabra por palabra.',
        sourceLumiUnversioned: 'El texto publicado por lumi.',
        sourceTenant: 'El texto propio de este espacio de trabajo, derivado de la versión {version} de lumi.',
        sourceTenantOwn: 'El texto propio de este espacio de trabajo.',
        none: 'El registro no llega tan atrás.',
        provenanceFollowing: 'Lo que consta: esta página es una copia de la versión {version} de lumi y aquí nadie la ha reescrito.',
        provenanceBranched: 'Lo que consta: esta página procede de la versión {version} de lumi y se reescribió el {date}.',
        provenanceUnknown: 'No consta nada más sobre esta página en el periodo anterior.',
        futureRefused: 'Este registro dice lo que una página mostró, no lo que mostrará. Elige un momento ya pasado.',
        invalidRefused: 'Elige una fecha y un idioma para la consulta.',
        failed: 'El registro no se ha podido leer ahora mismo. Inténtalo de nuevo.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Este aviso no está disponible en este momento.',
  },
  dataImportHub: {
    nav: 'Importación de datos',
    title: 'Importación y exportación de datos',
    intro: 'Importa y exporta datos heredados a los módulos desde un solo lugar. Cada acción se ejecuta en el módulo de destino con tu permiso allí.',
    locked: 'Sin permiso en este módulo',
    lockedDetail: 'Te falta el permiso de importación (data_import.manage) en {module}. Pídelo a un admin del módulo.',
    plan: {
      title: 'Plan de importación',
      run: 'Crear los valores que faltan',
      summary: 'Faltan {count} valores en {module} y pueden crearse allí como importación.',
      truncated: 'Lista truncada — se detectan hasta 200 valores por campo.',
      forbidden: 'Te falta el permiso en {module}.',
      running: 'Importación complementaria en curso…',
      waiting: 'Esperando a que los nuevos valores lleguen al módulo de destino…',
      rerunning: 'Repitiendo la prueba en el módulo de destino…',
      done: 'Listo — la prueba usa los nuevos valores.',
      failed: 'La importación complementaria falló.',
      confirmTitle: '¿Crear los valores que faltan?',
      confirmBody: 'Faltan {count} valores en {module}. ¿Crearlos ahora mediante una importación? La prueba se reinicia automáticamente después.',
      companionErrors: 'La prueba complementaria reporta errores — revísalo en el módulo.',
      projectionTimeout: 'La proyección al módulo de destino tarda más de lo esperado — reintenta la prueba más tarde.',
    },
    createField: {
      title: 'Crear un campo personalizado',
      intro: 'Crea un campo personalizado para la columna «{column}». Estará disponible en todo el ATS.',
      typeHint: 'Los campos de selección (select/selección múltiple) se crean en la gestión de campos.',
      sensitiveNotImportable: 'Los campos de categorías especiales (art. 9) se crean, pero deliberadamente no son destino de importación.',
      submit: 'Crear campo',
      label: 'Etiqueta',
      keyLabel: 'Clave del campo (Key)',
      keyHint: 'Solo letras minúsculas, números y guiones bajos',
      typeLabel: 'Tipo',
      types: {
        text: 'Texto',
        textarea: 'Área de texto',
        number: 'Número',
        date: 'Fecha',
        checkbox: 'Casilla de verificación',
      },
      sensitivityLabel: '¿Qué tipo de datos contiene este campo?',
      sensitivityUnanswered: 'Elige una opción',
      sensitivityNone: 'Ninguna categoría especial',
      sensitivityHint: 'Los datos de categorías especiales (art. 9 RGPD) no pueden provocar decisiones automatizadas sobre una candidatura.',
      sensitivityCategories: {
        racialEthnic: 'Origen racial o étnico',
        politicalOpinion: 'Opiniones políticas',
        religiousPhilosophical: 'Convicciones religiosas o filosóficas',
        tradeUnion: 'Afiliación sindical',
        genetic: 'Datos genéticos',
        biometricId: 'Identificación biométrica',
        health: 'Datos de salud',
        sexLifeOrientation: 'Vida sexual u orientación sexual',
      },
      sensitivityRequired: 'Indica qué tipo de datos contiene este campo.',
    },
    entities: {
      person: 'Empleados',
      orgUnit: 'Unidades org.',
      employmentContract: 'Contratos',
      job: 'Puestos',
      candidate: 'Candidatos',
      application: 'Candidaturas',
      client: 'Clientes',
      project: 'Proyectos',
      timeEntry: 'Registros de tiempo',
      leaveRequest: 'Ausencias',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      contractType: {
        permanent: 'indefinido',
        fixed_term: 'temporal',
        mini_job: 'minijob',
        midi_job: 'midijob (zona de transición)',
        working_student: 'estudiante en prácticas remuneradas',
        apprenticeship: 'formación profesional',
        internship: 'prácticas',
        freelance: 'autónomo / por honorarios',
        managing_director: 'gerente / miembro del consejo',
        other: 'otro',
      },
      workTimeArrangement: {
        full_time: 'jornada completa',
        part_time: 'jornada parcial',
        marginal: 'marginal (minijob)',
        variable: 'variable / flexible',
      },
      status: {
        draft: 'Borrador',
        active: 'Activo',
        on_hold: 'En pausa',
        terminated: 'Finalizado',
        inactive: 'Inactivo',
      },
      type: {
        department: 'Departamento',
        location: 'Ubicación',
        team: 'Equipo',
        cost_center: 'Centro de costes',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'ID externo',
        type: 'Tipo',
        name: 'Nombre',
        code: 'Código',
        description: 'Descripción',
        parentExternalId: 'Unidad superior',
        parentCode: 'Unidad superior (Código)',
        addressLine1: 'Dirección',
        postalCode: 'Código postal',
        city: 'Ciudad',
        country: 'País',
        active: 'Activo',
      },
      person: {
        externalId: 'ID externo',
        employeeNumber: 'Número de empleado',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        salutation: 'Tratamiento',
        gender: 'Género',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        birthDate: 'Fecha de nacimiento',
        nationality: 'Nacionalidad',
        maritalStatus: 'Estado civil',
        addressLine1: 'Dirección',
        addressLine2: 'Información adicional de dirección',
        postalCode: 'Código postal',
        city: 'Ciudad',
        country: 'País',
        workCountry: 'Lugar de trabajo (país)',
        primaryLocale: 'Idioma',
        status: 'Estado',
        primaryOrgUnitExternalId: 'Departamento / unidad',
        primaryOrgUnitCode: 'Departamento / unidad (Código)',
        supervisorExternalId: 'Responsable funcional',
      },
      employmentContract: {
        externalId: 'ID externo',
        personExternalId: 'Persona',
        contractReference: 'Número de contrato',
        status: 'Estado del contrato',
        startDate: 'Fecha de alta',
        endDate: 'Fecha de baja',
        probationEndDate: 'Fin del período de prueba',
        contractType: 'Tipo de contrato',
        position: 'Puesto / función',
        primaryOrgUnitExternalId: 'Departamento / unidad',
        supervisorExternalId: 'Responsable jerárquico',
        workTimeArrangement: 'Jornada laboral',
        weeklyHours: 'Horas semanales',
        vacationDaysPerYear: 'Vacaciones (días/año)',
        collectiveAgreementCode: 'Convenio colectivo',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Tipo de actor' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Roles', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Intentos de acceso fallidos repetidos', locked: 'Cuenta bloqueada' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Cuenta desbloqueada', disabled: 'Cuenta desactivada', enabled: 'Cuenta activada', closed: 'Cuenta cerrada' }, passkey: { revoked: 'Claves de acceso eliminadas por un administrador' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Propiedad transferida', member_removed: 'Miembro eliminado', suite_roles_changed: 'Roles de Suite modificados' }, tenant: { created: 'Tenant creado', lifecycle: 'Tenant lifecycle change', exported: 'Tenant exportado' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'Configuración de IA modificada' }, tenant_role_editing: { changed: 'Edición de roles modificada' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Configuración elegida', demo_started: 'Modo demo iniciado', demo_seeded: 'Datos de demostración creados', demo_seed_failed: 'Error al crear los datos de demostración', demo_wipe_started: 'Borrado de la demostración iniciado', demo_wiped: 'Datos de demostración borrados', demo_wipe_failed: 'Error al borrar los datos de demostración', setup_finished: 'Configuración finalizada', demo_denied: 'Modo demo denegado', module_topup: 'Datos de demostración añadidos para el nuevo módulo', demo_reset_started: 'Restablecimiento de la demostración iniciado', demo_tier_switch_started: 'Cambio a la demostración completa iniciado', demo_rebuilt: 'Demostración reconstruida' }, company_profile: { created: 'Perfil de empresa creado', updated: 'Perfil de empresa actualizado' }, org_scenario: { activated: 'Escenario organizativo activado' }, people_data: { wiped: 'Datos de personal borrados' }, ats_data: { wiped: 'Datos de selección borrados' }, time_data: { wiped: 'Datos de registro horario borrados' }, apprentice_data: { wiped: 'Datos de formación borrados' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Pago cobrado', failed: 'Pago fallido', refunded: 'Pago reembolsado', chargeback: 'Contracargo recibido' }, invoice: { issued: 'Factura emitida' }, mandate: { created: 'Tarjeta añadida', replaced: 'Tarjeta sustituida' }, promo_code: { redeemed: 'Código promocional canjeado' }, billing_account: { converted: 'Prueba convertida a pago', delinquent: 'Cuenta en mora', purged: 'Datos de facturación purgados' }, dunning_case: { opened: 'Recobro iniciado' }, enforcement: { opened: 'Aplicación iniciada', advanced: 'Aplicación escalada', cleared: 'Aplicación anulada' }, billing_exempt: { changed: 'Exención de facturación modificada' }, billing_data: { wiped: 'Datos de facturación borrados', generated: 'Datos de facturación de prueba generados' }, checkout: { completed: 'Compra completada', denied: 'Compra denegada' }, job: { created: 'Puesto creado', updated: 'Puesto actualizado', submitted: 'Puesto enviado', archived: 'Puesto archivado', deleted: 'Puesto eliminado' }, application: { created: 'Candidatura recibida', updated: 'Candidatura actualizada', transitioned: 'Estado de la candidatura cambiado', withdrawn: 'Candidatura retirada', transferred: 'Candidatura trasladada a otra vacante', transfer_declined: 'Traslado de candidatura rechazado', rejected: 'Candidatura rechazada', deleted: 'Candidatura eliminada', emailed: 'Correo de candidatura enviado' }, interview: { proposed: 'Entrevista propuesta', confirmed: 'Entrevista confirmada', cancelled: 'Entrevista cancelada' }, candidate: { anonymized: 'Candidato anonimizado', emailed: 'Correo al candidato enviado', identity_changed: 'Datos del candidato cambiados', identity_split: 'Candidato separado en su propio registro', identity_merged: 'Candidatura trasladada al candidato con esta dirección' }, candidate_dossier: { accessed: 'El candidato consultó sus datos' }, workflow: { deleted: 'Flujo de trabajo eliminado', definition: { published: 'Flujo de trabajo publicado' } }, task: { blocking_overridden: 'Tarea bloqueante anulada', auto_cancelled: 'Tarea cancelada automáticamente' }, support_access: { requested: 'Acceso de soporte solicitado', approved: 'Acceso de soporte aprobado', denied: 'Acceso de soporte denegado', revoked: 'Acceso de soporte finalizado', expired: 'Acceso de soporte caducado', request_expired: 'Solicitud de acceso de soporte caducada' }, ai_action: { executed: 'Acción de IA ejecutada' }, assistant_run: { proposed: 'lumi propuso una acción', approved: 'Acción de lumi aprobada', refused: 'Acción de lumi rechazada', failed: 'Acción de lumi fallida' }, assistant_turn: { fanned_out: 'Solicitud de lumi repartida entre varios módulos' }, payroll_export_run: { created: 'Exportación de nómina iniciada', completed: 'Exportación de nómina completada', failed: 'Exportación de nómina fallida', downloaded: 'Exportación de nómina descargada' }, payroll_period: { closed: 'Mes de nómina cerrado', reopened: 'Mes de nómina reabierto' }, payroll_connection: { updated: 'Conexión de nómina modificada' }, payroll_master_data: { exported: 'Datos maestros de nómina exportados' }, wage_type: { created: 'Concepto salarial creado', updated: 'Concepto salarial actualizado', deleted: 'Concepto salarial eliminado', starter_catalog_applied: 'Conceptos salariales estándar añadidos' }, wage_assignment: { created: 'Componente salarial añadido', updated: 'Componente salarial modificado', deleted: 'Componente salarial eliminado' }, one_time_payment: { created: 'Pago único añadido', updated: 'Pago único modificado', deleted: 'Pago único eliminado' }, payslip: { filed: 'Nóminas archivadas' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Conecta tu proveedor de identidad (OIDC) para que tu equipo inicie sesión a través de él.',
    issuerUrl: 'URL del emisor (descubrimiento OIDC)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Déjalo vacío para conservar el secreto guardado',
    label: 'Nombre visible',
    allowedDomains: 'Dominios de correo permitidos (separados por comas)',
    jitEnabled: 'Crear usuarios automáticamente en el primer inicio de sesión (JIT)',
    jitDefaults: 'Acceso a módulos predeterminado para nuevos usuarios',
    jitModulePlaceholder: 'Elegir un módulo',
    jitRoles: 'Roles asignados',
    jitCatalogUnreadable: 'No se pudieron leer los roles de este módulo. Los roles guardados no cambian.',
    jitUnknownRole: '{key} (desconocido)',
    addJit: 'Añadir módulo',
    remove: 'Remove',
    redirectUri: 'URI de redirección (regístrala en tu IdP)',
    copy: 'Copiar',
    test: 'Probar conexión',
    testOk: 'Descubrimiento correcto.',
    testFailed: 'La prueba falló',
    save: 'Guardar',
    saved: 'Guardado.',
    delete: 'Eliminar conexión',
    deleteConfirm: '¿Eliminar realmente esta conexión SSO?',
    enforce: 'Exigir inicio de sesión solo mediante SSO',
    enforceHint: 'El inicio de sesión con contraseña se desactiva para todos, excepto los administradores del sistema y el propietario del espacio de trabajo.',
    noConnection: 'Aún no hay ninguna conexión SSO configurada.',
    deleted: 'Conexión eliminada.',
    enforceEnabled: 'Ahora el inicio de sesión solo es posible mediante SSO.',
    enforceDisabled: 'El inicio de sesión con contraseña vuelve a estar disponible.',
    jitNeedsVerifiedDomain: 'Los usuarios solo se crean automáticamente para direcciones de un dominio verificado.',
    domainsTitle: 'Dominios de correo',
    domainsIntro: 'Un dominio solo cuenta para el inicio de sesión SSO cuando hayas demostrado que es tuyo: publica este registro TXT en el DNS del dominio y luego compruébalo. Mientras tanto, las cuentas ya vinculadas siguen iniciando sesión.',
    domainStatus: { pending: 'Sin verificar', verified: 'Verificado', legacy: 'Verificar pronto' },
    domainLegacyUntil: 'Verificar antes del {date}',
    domainRecordName: 'Nombre del registro (TXT)',
    domainRecordValue: 'Valor del registro',
    domainVerify: 'Comprobar registro',
    domainVerified: '{domain} está verificado.',
    domainError: { record_not_found: 'Todavía no hay ningún registro TXT con este nombre. Los cambios de DNS pueden tardar un poco.', value_mismatch: 'Existe un registro TXT, pero su valor no coincide. Copia el valor exactamente.', dns_error: 'La consulta DNS ha fallado. Inténtalo de nuevo en unos minutos.' },
  },  users: { seatLimit: { bookMore: 'Las {booked} plazas de usuario contratadas están ocupadas. Contrata al menos {required} plazas de usuario para invitar a alguien más.', leaveFreelancer: 'Este workspace está en modo freelance: una persona, una plaza. Si sales del modo freelance, contratas {required} plazas de usuario y hay sitio para las personas que invites.', notified: 'Las {booked} plazas de usuario contratadas están ocupadas. El propietario del workspace y los Billing Managers pueden contratar más plazas.', cta: 'Contratar más plazas' }, removeSuccess: '{email} se ha eliminado de este espacio de trabajo.', saveSuccess: 'Cambios de acceso guardados para {email}.', saveFailedFor: 'No se pudo guardar {targets} para {email}: {reason}', saveFailedOthersSaved: 'Los demás cambios se guardaron.', suiteRolesTarget: 'los roles de suite', unsaved: 'Sin guardar', defaultRoleHint: 'Rol predeterminado para invitaciones internas', refreshFailed: 'No se pudo actualizar la lista de miembros. Recarga la página para ver el estado guardado.', title: 'Usuarios & Asignaciones', email: 'Correo electrónico', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Admin del workspace: gestiona miembros, acceso a módulos, SSO y seguridad.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Puede gestionar la facturación (facturas, tarjeta, plan).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Atiende los tickets de soporte (responder, escalar, cerrar).', suiteDataProtection: 'Delegado/a de protección de datos', suiteDataProtectionHint: 'Revisa y aprueba las solicitudes de los interesados y los borrados, y puede consultar los datos de los miembros en cada módulo activo.', suiteOwnerLocked: 'El propietario del workspace siempre es Admin.', saveFailed: 'No se pudo guardar la asignación', inviteSuccess: '{email} ha sido invitado correctamente', invite: { titleInternal: 'Invitar a un miembro', titleExternal: 'Invitar externamente', hintInternal: 'Recibe automáticamente el rol predeterminado en Tiempo y Personal — puedes añadir más roles justo después de invitar.', hintExternal: 'Sin roles predeterminados: sin un rol, esta persona no puede abrir ningún módulo. Configura su acceso justo después de invitar.', submit: 'Invitar', sentTitle: 'Invitación enviada', sentLead: 'Se ha invitado a {email} y aparece como Invitado.', sentBodyInternal: 'Ya tiene el rol predeterminado en Tiempo y Personal.', sentBodyExternal: 'Todavía sin roles — configura a qué puede acceder esta persona.', revoke: 'Retirar invitación', moreRoles: 'Más roles', setupRoles: 'Configurar roles', done: 'Listo', revokedTitle: 'Invitación retirada', revokedBody: '{email} ha sido eliminado del espacio de trabajo. El enlace de invitación ya no es válido.' }, removeUser: 'Eliminar', confirmRemove: '¿Seguro que quieres eliminar a {email} de este tenant? Se eliminarán todas las asignaciones de módulos.', statusActive: 'Activo', statusInvited: 'Invitado', statusDisabled: 'Desactivado', transferOwnership: 'Transferir la propiedad', transferTitle: 'Transferir la propiedad del workspace', transferIntro: '{from} entrega este workspace a {to}. Solo hay un propietario: al confirmar, {from} deja de serlo.', transferConsequences: 'Esto es lo que cambia:', transferConsequenceBreakGlass: 'El acceso de emergencia cuando falla el SSO pasa a {to}: si vuestro proveedor de identidad no está disponible, {to} podrá seguir entrando con contraseña; {from} ya no.', transferConsequenceOutgoing: '{from} conserva todos los roles que ya tiene, incluido Admin — solo cambia la propiedad. Se le puede desactivar o eliminar como a cualquier otro miembro.', transferConsequenceSuiteAdmin: '{to} recibe el rol Admin si aún no lo tiene. Nadie pierde ningún rol.', transferSsoWarning: '{email} inicia sesión mediante SSO y no tiene contraseña. Si el SSO no está disponible, no podrá usar el acceso de emergencia que hereda; puede establecer una contraseña en cualquier momento con «He olvidado mi contraseña».', transferBlockedPending: '{email} aún no ha aceptado la invitación. Tiene que aceptarla antes de poder ser propietario.', transferBlockedDisabled: 'La cuenta de {email} está desactivada. Actívala de nuevo antes de transferir la propiedad.', transferConfirmFieldLabel: 'Confirma el nuevo propietario', transferConfirmHint: 'Escribe {email} para activar el botón.', transferSuccess: '{email} ya es propietario de este workspace.', transferFailed: 'No se pudo transferir la propiedad. Inténtalo de nuevo.', transferErrorForbidden: 'Solo el propietario actual puede transferir la propiedad.', transferErrorNotMember: '{email} ya no es miembro de este workspace.', transferErrorAlreadyOwner: '{email} ya es propietario de este workspace.', transferErrorRaced: 'La propiedad cambió mientras se realizaba esta transferencia. Recarga la lista e inténtalo de nuevo.', transferErrorIneligible: '{email} no puede asumir la propiedad ahora mismo. Actualiza la lista para ver su estado actual.', resendInvite: 'Reenviar invitación', disable: 'Desactivar', enable: 'Activar', confirmDisable: '¿Desactivar a {email}? Se cerrará su sesión de inmediato y no podrá iniciar sesión hasta que reactives la cuenta.', resendSuccess: 'Invitación reenviada a {email}.', resendEmailFailed: 'No se pudo enviar el correo de invitación a {email}. Inténtalo de nuevo.', disableSuccess: '{email} ha sido desactivado.', enableSuccess: '{email} ha sido activado.', inviteEmailFailed: '{email} se ha añadido, pero no se pudo enviar el correo de invitación. Puedes reenviarlo.', searchPlaceholder: 'Buscar por correo electrónico', rolesFilterPlaceholder: 'Filtrar por rol', clearRolesFilter: 'Restablecer filtro', memberCount: '{count} miembros', memberCountFiltered: '{shown} de {count} miembros', inviteInternal: 'Invitar', inviteExternal: 'Invitar externamente', removeRoleFilter: 'Quitar rol del filtro', columns: { account: 'Cuenta', status: 'Estado', roles: 'Roles' },moduleNames: { ats: 'Reclutamiento', time_tracking: 'Tiempo', people: 'Personal', apprenticeship: 'Ausbildung' }, accessDenied: 'Acceso denegado', moreActions: 'Más acciones para {email}', noSearchResults: 'Ningún miembro coincide con «{query}».', editSubtitle: 'Editar roles y acceso', suiteConfirmGrantTitle: '¿Asignar un rol de suite?', suiteConfirmRevokeTitle: '¿Retirar un rol de suite?', suiteConfirmMixedTitle: '¿Cambiar los roles de suite?', suiteConfirmLead: 'Esto cambia para {email}:', suiteConfirmRemoved: 'Pierde {role}.', suiteConfirmAccept: 'Sí, guardar' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'Conectar un agente de IA',
    heading: 'Un agente de IA quiere actuar en su nombre',
    intro: 'Un cliente de IA que se presenta como «{client}» solicita trabajar en lumi en su nombre, en el espacio de trabajo {workspace}.',
    fields: {
      client: 'Se presenta como',
      redirectHost: 'Le devuelve a',
      website: 'Sitio web indicado',
      workspace: 'En el espacio de trabajo',
    },
    scopesHeading: 'Solicita:',
    scope: {
      read: 'Leer lo que usted puede ver en lumi',
      act: 'Proponer y realizar acciones en su nombre — cada acción requiere su confirmación',
      ask: 'Hacer preguntas a lumi',
    },
    meaning: {
      heading: 'Qué significa «Permitir»',
      asYou: 'Actúa como usted, exactamente con sus permisos en este espacio de trabajo — nunca con más.',
      egress: 'Todo lo que lea en lumi se envía al proveedor que hay detrás de «{client}», fuera de lumi.',
      revocable: 'Puede terminar la conexión en cualquier momento en la página de su cuenta.',
    },
    standing: {
      label: 'Realizar acciones sobre mis propios registros sin preguntar cada vez',
      hint: 'Nunca cubre registros de otras personas ni decisiones desfavorables: en esos casos siempre se pregunta. Puede cambiarlo en cualquier momento en la página de su cuenta.',
    },
    rolePins: {
      title: 'Rol por módulo',
      hint: 'Donde tenga más de un rol, elija aquel con el que trabaja el agente. Nunca puede hacer más de lo que ese rol permite.',
      default: 'Predeterminado del módulo ({rule})',
      defaultRule: {
        first_assigned: 'su primer rol asignado',
        first_by_key: 'su primer rol según su clave',
        all_roles: 'todos sus roles a la vez',
      },
      modules: {
        ats: 'Reclutamiento',
        time: 'Tiempo',
        people: 'Personal',
      },
      notHeld: 'Ya no tiene el rol elegido en ese módulo. Elija de nuevo.',
    },
    disabled: {
      title: 'Los agentes de IA externos están desactivados en este espacio de trabajo',
      body: 'Un propietario o administrador puede activarlos en Administración → Agentes de IA externos. Hasta entonces, solo puede rechazar esta solicitud.',
    },
    actions: {
      allow: 'Permitir',
      deny: 'Rechazar',
    },
    returning: 'Volviendo a {client}…',
    invalid: {
      title: 'Esta solicitud de inicio de sesión ya no es válida',
      hint: 'Vuelva a iniciar la conexión desde su cliente de IA.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Agentes de IA externos',
    cardTitle: 'Agentes de IA externos',
    noAccess: 'Sin acceso',
    noAccessHint: 'Solo el propietario del espacio de trabajo y los administradores de la suite pueden cambiar este ajuste.',
    intro: 'Con esta opción activada, los miembros pueden conectar su propio cliente de IA — Claude Code, OpenClaw, … — y dejar que actúe en su nombre en este espacio de trabajo.',
    points: {
      asMember: 'Un agente trabaja exactamente con los permisos del miembro que lo conectó — nunca con más.',
      confirmed: 'Ese miembro confirma cada acción que propone antes de que se realice.',
      adverse: 'Las decisiones desfavorables sobre otras personas siempre requieren el panel de lumi; un agente nunca puede confirmarlas.',
    },
    egress: {
      title: 'Adónde van los datos de los miembros',
      body: 'Todo lo que lee un agente se envía al cliente de IA que conecta el miembro: un destinatario fuera de la cadena de encargados del tratamiento de lumi, elegido por su espacio de trabajo y por el miembro.',
      worksCouncil: 'Si los miembros pueden usar estos clientes es una decisión suya como empleador; considere implicar al comité de empresa.',
    },
    switchLabel: 'Permitir a los miembros conectar agentes de IA externos',
    saving: 'Guardando…',
    activeConnections: 'No hay ninguna conexión activa. | 1 conexión activa. | {n} conexiones activas.',
    offHint: 'Al desactivarlo se terminan de inmediato todas las conexiones de este espacio de trabajo.',
    roleNote: 'Solo el propietario del espacio de trabajo o un administrador de la suite puede cambiarlo.',
    savedOn: 'Los agentes de IA externos están activados. Los miembros ya pueden conectar su cliente de IA.',
    savedOff: 'Los agentes de IA externos están desactivados. | Los agentes de IA externos están desactivados. Se terminó 1 conexión. | Los agentes de IA externos están desactivados. Se terminaron {n} conexiones.',
    disableConfirm: {
      title: '¿Desactivar los agentes de IA externos?',
      body: 'Ahora no hay ninguna conexión activa; los miembros ya no podrán conectarse. | Esto termina de inmediato 1 conexión. | Esto termina de inmediato {n} conexiones.',
      confirm: 'Desactivar',
    },
  },
  supportAccess: {
    revokeConfirm: 'El acceso de soporte termina de inmediato. El equipo de soporte pierde el acceso a este espacio de trabajo.',
    title: 'Acceso de soporte',
    subtitle: 'Acceso temporal a su espacio, autorizado por usted, para nuestro equipo de soporte.',
    noAccess: 'Sin acceso',
    noAccessHint: 'Solo el propietario del espacio y los administradores de la suite pueden revisar estas solicitudes.',
    empty: 'No se ha solicitado acceso de soporte',
    emptyHint: 'Cuando nuestro soporte necesite acceder a su espacio para atender un ticket, la solicitud aparecerá aquí.',
    pendingTitle: 'Solicitud de acceso pendiente',
    pendingIntro: '{supporter} solicita {days} días de acceso a este espacio.',
    activeTitle: 'El acceso de soporte está activo',
    activeIntro: '{supporter} puede trabajar actualmente en este espacio.',
    historyTitle: 'Historial',
    revokeHint: 'Finalizar el acceso surte efecto en menos de un minuto.',
    expiringNow: 'Caducando ahora',
    remainingDays: 'quedan {days} d {hours} h',
    remainingHours: 'quedan {hours} h {minutes} min',
    remainingMinutes: 'quedan {minutes} min',
    fields: {
      requestedAt: 'Solicitado',
      ticket: 'Ticket de soporte',
      duration: 'Duración',
      durationValue: '{days} días',
      reason: 'Motivo indicado',
      approvedBy: 'Aprobado por',
      expiresAt: 'Caduca',
      remaining: 'Tiempo restante',
      grantedModules: 'Roles concedidos',
    },
    consent: { allRoles: 'La persona de soporte puede cambiar a cualquier rol que ofrezcan estos módulos: ve lo que ven tus empleados, no solo la vista de administración.', modulesHeading: 'Este acceso cubre:', via: 'a través de {module}',
      heading: 'Lo que está aprobando',
      data: 'El soporte podrá acceder a los datos de este espacio en todos los módulos activos, incluidos los datos personales de empleados y candidatos.',
      audited: 'Cada acción queda registrada en su registro de auditoría y marcada como acción de soporte.',
      duration: 'El acceso termina automáticamente tras {days} días.',
      revocable: 'Puede finalizarlo en cualquier momento; surte efecto en menos de un minuto.',
    },
    actions: { approve: 'Aprobar el acceso', deny: 'Denegar', revoke: 'Finalizar ahora' },
    status: {
      requested: 'Pendiente',
      active: 'Activo',
      denied: 'Denegado',
      revoked: 'Finalizado',
      expired: 'Caducado',
      request_expired: 'Solicitud caducada',
    },
    columns: { supporter: 'Cuenta de soporte', requestedAt: 'Solicitado', status: 'Estado', endedAt: 'Finalizado' },
    success: { approved: 'Acceso de soporte aprobado.', denied: 'Solicitud denegada.', revoked: 'Acceso de soporte finalizado.' },
    errors: {
      consentChanged: 'El texto de consentimiento ha cambiado. Léalo de nuevo antes de aprobar.',
      selfApproval: 'La cuenta solicitante no puede aprobar su propia solicitud.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Normas legales y acuerdos',
    intro: 'Las normas legales se aplican automáticamente y se mantienen actualizadas de forma centralizada. Aquí solo indicas dónde tu empresa se aparta de ellas: cada excepción necesita una base, por ejemplo un convenio colectivo o un acuerdo de empresa.',
    disclaimer: 'Valores orientativos según la ley – no es asesoramiento jurídico. Los convenios colectivos pueden ser más estrictos.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Aún sin revisar',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi empieza con las normas legales por defecto. Si os encajan, confírmalo. Si en vuestra empresa rige un convenio colectivo o un acuerdo de empresa, crea una excepción más abajo.',
        confirm: 'Revisado, nos encaja',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi empieza con las normas legales por defecto – jornada máxima, pausas, descanso. Decide qué ocurre cuando un registro incumple alguna y confirma después que las normas encajan con vuestra empresa.',
        standard: 'Por defecto',
        later: 'Puedes cambiar ambas cosas más adelante en cualquier momento.',
        agreements: '¿Rige en vuestra empresa un convenio colectivo o un acuerdo de empresa por el que una norma es distinta o no se aplica? Entonces crea abajo una {basis} – los avisos se rigen por ella. No existe un modo sin avisos.',
        agreementsBasis: 'excepción con su fundamento',
        flexible: {
          personLabel: 'La persona', personText: 've al guardar qué norma se incumple y en cuánto – el registro se mantiene.',
          managerLabel: 'La dirección', managerText: 've los incumplimientos de la semana al aprobar y decide junto con la persona.',
          recordLabel: 'El historial', recordText: 'anota cada incumplimiento – para vosotros, no contra vosotros.',
        },
        strict: {
          personLabel: 'La persona', personText: 'no puede guardar un registro que incumple una norma de obligado cumplimiento – y ve por qué. Una pausa que falta se guarda y se muestra.',
          managerLabel: 'La dirección', managerText: 'al aprobar solo ve lo que aun así se produce: pausas que faltan y cierres automáticos.',
          fitLabel: 'Encaja si', fitText: 'en vuestra empresa no puede haber excepciones – por ejemplo con menores.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Guardado. Con esto las reglas de jornada aún no están confirmadas: confirma ahora que se ajustan a vosotros.', confirm: 'Confirmar ahora' },
      confirmed: { title: 'Revisado', body: 'Confirmado el {date} por {name}: las normas legales nos encajan.', bodyNoName: 'Confirmado el {date}: las normas legales nos encajan.' },
      ownDeviation: { title: 'Revisado', body: 'Vuestro espacio de trabajo tiene excepciones propias, así que las normas ya se han revisado.' },
      error: 'No se pudo guardar la confirmación. Inténtalo de nuevo.',
    },
    noJurisdictions: 'Aún no hay ninguna jurisdicción: no hay personas con lugar de trabajo ni jurisdicción predeterminada. Elige una más abajo y aquí aparecerán las normas legales.',
    jurisdictionEu: 'Directiva de la UE',
    jurisdictionDefault: '{name} (predeterminada)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Jurisdicción {country}: estas reglas no se aplican ahora a nadie. | Jurisdicción {country}: estas reglas valoran la jornada de 1 persona en Tiempo que trabaja aquí. | Jurisdicción {country}: estas reglas valoran la jornada de {count} personas: todos los empleados activos en Tiempo que trabajan aquí.',
    headcountLineDefault: 'Jurisdicción {country}: estas reglas no se aplican ahora a nadie. | Jurisdicción {country}: estas reglas valoran la jornada de 1 persona en Tiempo que trabaja aquí o a la que se aplica la jurisdicción predeterminada. | Jurisdicción {country}: estas reglas valoran la jornada de {count} personas: todos los empleados activos en Tiempo que trabajan aquí o a los que se aplica la jurisdicción predeterminada.',
    fallbackLine: 'Personas sin lugar de trabajo, o con uno que el catálogo no cubre: {count}; se les aplica {country}.',
    createModels: 'Crear los modelos de tiempo de trabajo de este país',
    domains: {
      workingTime: 'Tiempo de trabajo',
      pay: 'Franjas con recargo',
      overtime: 'Horas extra',
      leave: 'Vacaciones',
    },
    rules: {
      maxDailyHours: 'Jornada máxima diaria',
      maxWeeklyHours: 'Jornada máxima semanal',
      breaks: 'Pausas',
      minDailyRest: 'Descanso diario',
      nightWorkBan: 'Prohibición de trabajo nocturno',
      minWeeklyRest: 'Descanso semanal',
      avgWeeklyHours: 'Jornada semanal media',
      normalDailyHours: 'Jornada ordinaria diaria',
      normalWeeklyHours: 'Jornada ordinaria semanal',
      nightWindow: 'Horario nocturno para recargos',
      nightCoreWindow: 'Franja nocturna central para recargos superiores',
      overtimeThreshold: 'Horas extra a partir de (horas semanales)',
      overtimeSurcharge: 'Recargos por horas extra',
      minLeaveDays: 'Vacaciones anuales mínimas',
    },
    kinds: {
      collectiveAgreement: 'Convenio colectivo',
      worksAgreement: 'Acuerdo de empresa',
      authorityPermit: 'Autorización administrativa',
      companyPolicy: 'Norma interna',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} días',
      breakStage: '{minutes} min a partir de {hours} h',
      weeklyAverage: '{hours} h de media en {weeks} semanas',
      nightWorkBan: 'sin trabajo entre las {start} y las {end}',
      tierFirst: '{percent} % desde la primera hora extra',
      tierAfter: '{percent} % tras {hours} horas extra',
      none: 'Ninguna norma',
      switchedOff: 'La norma no se aplica (desactivada)',
    },
    status: {
      statutory: 'Según la ley',
      noStatutoryRule: 'Sin norma legal',
      infoOnly: 'Solo informativo',
      deviation: 'Excepción',
      deviationStricter: 'Excepción · más estricta',
      deviationLooser: 'Excepción · más flexible',
      deviationMoreFavourable: 'Excepción · más favorable que la ley',
      deviationLessFavourable: 'Excepción · menos favorable que la ley',
      deviationEqual: 'Excepción · igual que la ley',
      deviationMixed: 'Excepción · en parte más estricta, en parte más flexible',
      deviationMixedFavourable: 'Excepción · en parte más favorable, en parte menos',
    },
    hint: {
      stricter: 'Más estricto que la ley: permitido con cualquier base.',
      looser: 'Más flexible que la ley: necesita como base un convenio colectivo, un acuerdo de empresa o una autorización administrativa.',
      moreFavourable: 'Más favorable que la ley: permitido con cualquier base.',
      lessFavourable: 'Menos favorable que la ley: necesita como base un convenio colectivo, un acuerdo de empresa o una autorización administrativa.',
      mixed: 'En parte más estricto y en parte más flexible que la ley: necesita como base un convenio colectivo, un acuerdo de empresa o una autorización administrativa.',
      mixedFavourable: 'En parte más favorable y en parte menos favorable que la ley: necesita como base un convenio colectivo, un acuerdo de empresa o una autorización administrativa.',
      equal: 'Igual que el valor legal: no hace falta una excepción.',
      incomparable: 'En esta norma no hay «más estricto» ni «más flexible»: sirve cualquier base.',
      blocked: 'Una norma interna no puede quedarse por debajo de la ley. Elige como base un convenio colectivo, un acuerdo de empresa o una autorización administrativa, o un valor que al menos iguale la ley.',
    },
    table: {
      rule: 'Norma',
      applies: 'Se aplica',
      note: 'Nota sobre la situación legal',
      deviate: 'Establecer excepción',
      backToStatute: 'Volver a la ley',
      statutoryWouldBe: 'Por ley sería: {value}',
      statutoryWouldBeNone: 'La ley no establece ninguna norma aquí.',
      basis: 'Base: {name}',
      basisWithClause: 'Base: {name}, {clause}',
      coveredDeviation: 'Con el código de convenio {code}: {value} ({name})',
      futureDeviation: 'Desde el {date}: {value} ({name})',
      fallbackApplies: 'La ley no fija aquí ninguna franja: se aplica esta hasta que un acuerdo fije otra.',
      fallbackWouldBe: 'La ley no fija aquí ninguna franja: sin la excepción sería {value}',
      editDeviationOf: 'Editar la excepción de «{name}»',
      backToStatuteOf: 'Devolver a la ley la excepción de «{name}»',
    },
    notice: {
      fallback: 'El catálogo de normas legales no está disponible temporalmente. Se muestra la base integrada; pueden faltar cambios recientes.',
      unjudged: 'Personas a las que ahora no se aplica ninguna norma legal: {count}. No tienen lugar de trabajo y no hay jurisdicción predeterminada: elige una más abajo.',
      upcoming: 'Desde el {date}, la norma legal «{rule}» cambia a: {value}.',
      upcomingNone: 'Desde el {date}, la norma legal «{rule}» deja de aplicarse.',
      upcomingDeviationStays: 'Tu excepción se mantiene.',
      reviewTitle: 'Revisar: {rule}',
      review: 'El valor legal ha cambiado desde que se estableció esta excepción ({agreement}). La ley dice ahora: {statutory}. Tu excepción: {deviation}.',
      keepDeviation: 'Mantener la excepción',
    },
    minors: {
      title: 'Menores de 18 años',
      headcount: 'Personas: {count}',
      headcountNone: 'ninguna actualmente',
      hint: 'A las personas menores de 18 años se les aplican estas normas legales de protección de menores en lugar de las generales, automáticamente según la fecha de nacimiento registrada en Personal. Los acuerdos no se apartan de ellas.',
      generalApplies: 'Aún sin norma propia: hasta entonces se aplica la general.',
      upcoming: 'Desde el {date}: {value}',
      upcomingNone: 'Desde el {date}, esta norma de protección de menores deja de aplicarse.',
    },
    form: {
      value: 'Valor de la excepción',
      daysUnit: 'días',
      stageAfterHours: 'Tiempo de trabajo superior a (h)',
      stageMinutes: 'Pausa total (min)',
      tierAfterHours: 'A partir de (horas extra por semana)',
      tierPercent: 'Recargo (%)',
      addStep: 'Añadir tramo',
      removeStep: 'Quitar tramo {row}',
      stageAfterHoursRow: 'Tramo {row}: tiempo de trabajo superior a (h)',
      stageMinutesRow: 'Tramo {row}: pausa total (min)',
      tierAfterHoursRow: 'Tramo {row}: a partir de (horas extra por semana)',
      tierPercentRow: 'Tramo {row}: recargo (%)',
      averageHours: 'Horas semanales de media',
      averageWeeks: 'Periodo de referencia (semanas)',
      windowStart: 'Inicio',
      windowEnd: 'Final',
      windowHint: 'Si el final es anterior al inicio, la franja pasa de medianoche.',
      statutoryIs: 'La ley establece: {value}',
      comparisonBase: 'Sin norma legal se aplica {value}: la excepción se mide con respecto a ese valor.',
      basis: 'Base',
      basisHint: 'El acuerdo en el que se apoya la excepción.',
      basisPick: 'Elegir una base…',
      basisNew: 'Crear una base nueva…',
      basisRequired: 'Elige una base.',
      clause: 'Cláusula',
      clauseHint: 'Dónde figura la disposición, p. ej. «art. 4.2». Opcional.',
      invalid: {
        hours: 'Indica las horas: más de 0 y como máximo 168.',
        days: 'Indica los días: más de 0 y como máximo 366.',
        breakLadder: 'Revisa los tramos: de 1 a 6, en orden ascendente según el tiempo de trabajo (más de 0 y hasta 24 h), con una pausa de más de 0 y hasta 480 min que nunca sea menor que la del tramo anterior.',
        weeklyAverage: 'Revisa los valores: horas de más de 0 y como máximo 168, periodo de referencia de 1 a 104 semanas.',
        timeWindow: 'Indica una hora de inicio y otra de fin; deben ser distintas.',
        percentTiers: 'Revisa los tramos: de 1 a 6, el primero desde 0 horas extra y los demás en orden ascendente; recargo entre 0 y 300 %, con dos decimales como máximo.',
      },
    },
    agreement: {
      name: 'Nombre',
      title: 'Acuerdos',
      subtitle: 'Convenios colectivos, acuerdos de empresa, autorizaciones y normas internas: las bases de tus excepciones.',
      new: 'Nuevo acuerdo',
      edit: 'Editar acuerdo',
      empty: 'Aún no hay acuerdos: se aplican en todo las normas legales.',
      inactive: 'No vigente actualmente',
      migrated: 'Trasladado de la configuración anterior',
      noDeviations: 'Aún sin excepciones. Establécelas arriba, en la norma correspondiente.',
      needsReview: 'Revisar',
      kind: 'Tipo de acuerdo',
      companyPolicyHint: 'Una norma interna solo puede ser más estricta o más favorable que la ley.',
      nameHint: 'Por ejemplo, «Convenio del metal» o «Acuerdo de pausas 2026».',
      nameRequired: 'Pon un nombre al acuerdo.',
      reference: 'Número de referencia',
      referenceHint: 'Opcional, p. ej. el número de registro o de resolución.',
      jurisdiction: 'Jurisdicción',
      validFrom: 'Vigente desde',
      validFromRequired: 'Indica desde cuándo se aplica el acuerdo.',
      validTo: 'Vigente hasta',
      validToHint: 'Déjalo vacío si el acuerdo no tiene fecha de fin.',
      validSince: 'vigente desde el {from}',
      validRange: 'vigente del {from} al {to}',
      scope: 'Se aplica a',
      scopeAll: 'todas las personas de esta jurisdicción',
      scopeCovered: 'solo las personas vinculadas al convenio',
      scopeCoveredCode: 'solo el código de convenio {code}',
      coverageCode: 'Código de convenio',
      coverageCodeHint: 'El código se indica en el contrato laboral de la persona en Personal. El acuerdo solo se aplica a quienes tengan exactamente este código.',
      deleteTitle: '¿Eliminar «{name}»?',
      deleteConfirm: 'Al eliminar el acuerdo se eliminan también sus excepciones (número: {count}). Esas normas volverán a seguir la ley.',
      deleteConfirmEmpty: 'El acuerdo no tiene excepciones; las normas vigentes no cambian.',
      editDeviation: 'Editar excepción: {rule}',
      removeDeviation: 'Volver a la ley: {rule}',
    },
    backConfirm: {
      title: '«{rule}»: ¿volver a la ley?',
      body: 'Se eliminará la excepción. Después volverá a aplicarse el valor legal: {value}.',
      bodyNone: 'Se eliminará la excepción. La ley no establece ninguna norma aquí: después no se aplicará ninguna.',
      bodyFallback: 'Se eliminará la excepción. La ley no establece ninguna norma aquí: después volverá a aplicarse {value}.',
    },
    workspace: {
      title: 'Ajustes del espacio de trabajo',
      defaultJurisdiction: 'Jurisdicción predeterminada',
      defaultJurisdictionHint: 'Se aplica a las personas sin lugar de trabajo o con uno que el catálogo no cubre.',
      noDefault: 'Sin valor predeterminado',
      mode: 'Cuando un registro incumple una norma',
      modeFlexible: 'Avisar y registrar',
      modeFlexibleHint: 'El registro se guarda. El incumplimiento se muestra y queda registrado.',
      modeStrict: 'Bloquear el registro',
      modeStrictHint: 'Un registro que incumple una norma de obligado cumplimiento no se puede guardar.',
      originSignup: 'Tomado del país que indicó tu empresa al registrarse: {country}.',
      originFallbackPrevious: 'Hasta que se conozca el país que tu empresa indicó al registrarse y esté en el catálogo, se aplican las normas de {current}, con las que se evaluaba hasta ahora este espacio de trabajo.',
      originFallbackUnknown: 'Aún no se conoce el país de tu empresa, así que se aplica el mínimo de la UE hasta que alguien elija aquí el país.',
      originFallbackUncovered: 'Al registrarse, tu empresa indicó {country}. El catálogo aún no tiene normas para ese país, así que se aplica el mínimo de la UE.',
      originFallbackCovered: 'Al registrarse, tu empresa indicó {country}, cuyas normas ya están en el catálogo. Elígelo aquí para aplicarlas; hasta entonces se aplica el mínimo de la UE.',
    },
    toast: {
      settingsSaved: 'Configuración guardada',
      deviationSaved: 'Excepción guardada',
      deviationConfirmed: 'Excepción confirmada',
      backToStatute: 'Excepción eliminada: vuelve a aplicarse la ley',
      agreementSaved: 'Acuerdo guardado',
      agreementDeleted: 'Acuerdo eliminado',
      modelsCreated: 'Modelos de tiempo de trabajo creados: {count}',
      modelsExist: 'Los modelos de tiempo de trabajo de este país ya existen.',
    },
    errors: {
      rival: '«{name}» ya establece esta norma para las mismas personas en un periodo que se solapa.',
      validToBeforeFrom: 'El fin de la vigencia no puede ser anterior a su inicio.',
      coverageCodeRequired: 'Indica el código de convenio al que se aplica el acuerdo.',
      invalidValue: 'El valor no es válido para esta norma. Revísalo.',
      jurisdictionUnknown: 'Esta jurisdicción no figura en el catálogo de normas legales.',
      dateInvalid: 'Indica una fecha válida.',
      labelInvalid: 'Revisa los campos de texto: el nombre es obligatorio y ningún campo puede superar los 160 caracteres.',
      noModelPresets: 'No hay modelos de tiempo de trabajo preparados para este país.',
      kindInvalid: 'Elige el tipo de acuerdo de la lista.',
      modeInvalid: 'Elige qué ocurre cuando un registro incumple una norma.',
      ruleUnknown: 'Esta versión de la aplicación no conoce esta norma. Vuelve a cargar la página.',
      ruleInfoOnly: 'Esta norma se muestra solo a título informativo: no admite excepciones.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Tiempo no está activo en este espacio de trabajo',
      timeInactive: 'Las normas legales se aplican al tiempo de trabajo registrado en Tiempo. En cuanto Tiempo forme parte de este espacio de trabajo, aquí indicarás en qué se aparta tu empresa de ellas.',
      noAccess: 'No puedes gestionar las normas legales de este espacio de trabajo. Pueden hacerlo la persona propietaria del espacio de trabajo, la administración de suite y los miembros de Tiempo con permiso para gestionar el cumplimiento.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Profesiones de formación',
    columns: {
      occupation: 'Profesión de formación',
      duration: 'Duración',
      regulation: 'Reglamento de formación',
      apprentices: 'Aprendices',
    },
    duration: '{count} meses',
    regulationIssued: 'del {date}',
    regulationValidFrom: 'en vigor desde el {date}',
    areas: {
      IH: 'Industria y comercio (IHK)',
      Hw: 'Artesanía (HWK)',
      oeD: 'Servicio público',
      Lw: 'Agricultura',
      FB: 'Profesiones liberales',
      Hausw: 'Economía doméstica',
      See: 'Navegación marítima',
    },
    branches: {
      specialisations: 'Especialidades',
      focuses: 'Orientaciones',
      any: 'Especialidades / orientaciones',
    },
    requirements: {
      onWall: 'Posiciones del reglamento de formación en el muro de habilidades: {count}',
      version: 'reglamento del {date}',
      none: 'Las posiciones del reglamento de formación aún no están disponibles. Aparecerán en el muro de habilidades en cuanto el operador de la plataforma las haya importado.',
      versions: 'Los aprendices se forman según {count} versiones del reglamento: cada uno sigue con la versión que estaba en vigor al comenzar su formación.',
    },
    state: {
      notSelectable: 'Ya no se puede seleccionar',
      notSelectableHint: 'El operador de la plataforma ya no ofrece esta profesión para nuevas selecciones. Tu espacio de trabajo la conserva junto con sus aprendices, pero una vez que la quites no podrá volver a añadirse.',
      withdrawn: 'Reconocimiento retirado',
      withdrawnHint: 'El reconocimiento estatal de esta profesión se ha derogado, o ya no figura en el registro de profesiones de formación reconocidas. Los aprendices en curso terminan su formación; no puede volver a añadirse.',
      unknown: 'No está en el catálogo',
      unknownHint: 'Esta entrada se escribió antes de que existiera el catálogo y no coincide con ninguna de sus profesiones. Solo se puede quitar: añade en su lugar la profesión correspondiente del catálogo.',
    },
    offered: {
      title: 'Nuestra oferta',
      intro: 'Las profesiones de formación reconocidas en las que forma tu empresa. Solo estas pueden elegirse para un aprendiz.',
      emptyTitle: 'Aún no se ofrece ninguna profesión de formación',
      empty: 'Elige en el catálogo de abajo las profesiones en las que forma tu empresa. Después podrás asignarlas a tus aprendices.',
      browse: 'Elegir del catálogo',
      remove: 'Quitar',
      removeNamed: 'Quitar {title} de la oferta',
    },
    catalogue: {
      title: 'Añadir desde el catálogo',
      intro: 'Las profesiones de formación reconocidas en Alemania que tu espacio de trabajo aún no ofrece. El catálogo se mantiene actualizado de forma centralizada.',
      unavailableTitle: 'El catálogo no está disponible en este momento',
      unavailable: 'Tu oferta de arriba se muestra a partir de lo que este espacio de trabajo tiene guardado. Se podrán volver a añadir profesiones en cuanto el catálogo esté disponible.',
      allOffered: 'Tu espacio de trabajo ya ofrece todas las profesiones del catálogo.',
      searchPlaceholder: 'Título o especialidad',
      areaLabel: 'Ámbito',
      areaAll: 'Todos los ámbitos',
      count: 'Profesiones encontradas: {shown} de {total}',
      noMatches: 'Ninguna profesión coincide con tu búsqueda.',
      resetFilters: 'Restablecer la búsqueda',
      showMore: 'Mostrar más',
      add: 'Añadir',
      addNamed: 'Añadir {title} a la oferta',
    },
    removeConfirm: {
      title: '¿Quitar «{title}» de la oferta?',
      apprentices: 'Aprendices asignados actualmente a esta profesión: {count}. Conservan su profesión y terminan su formación; simplemente ya no podrá elegirse para nuevos aprendices.',
      final: 'Una vez quitada, esta profesión no podrá volver a añadirse.',
      confirm: 'Quitar de la oferta',
    },
    toast: {
      added: '«{title}» ya forma parte de tu oferta',
      removed: '«{title}» ya no se ofrece',
    },
    errors: {
      notOfferable: 'No se pudo añadir «{title}»: la profesión se ha desactivado o retirado entretanto. La lista se ha actualizado.',
      catalogueUnavailable: 'El catálogo no está disponible en este momento, por lo que no se puede añadir nada. Inténtalo de nuevo más tarde.',
    },
    page: {
      moduleInactiveTitle: 'Formación no está activo en este espacio de trabajo',
      moduleInactive: 'Las profesiones de formación se ofrecen para los aprendices gestionados en el módulo Formación. En cuanto forme parte de este espacio de trabajo, aquí elegirás en qué profesiones forma tu empresa.',
      noAccess: 'No puedes gestionar las profesiones de formación de este espacio de trabajo. Pueden hacerlo la persona propietaria del espacio de trabajo, la administración de suite y los miembros del módulo Formación con permiso para gestionarlo.',
    },
  },
};
